

export const roles = ['Super Admin','Admin']


// let companyName = 
export const FeedbackAndComplaintsUserFlowCustomizations = [
  {
    companyId: '689a05a381ed7516c690aad5',
    Feedback: {
      label: 'Submit Feedback',
     shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
       description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'
  },
  {
    companyId: '689ae8f23ee3397ebc359528',
    Feedback: {
      label: 'Submit Feedback',
      shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
      description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'

  },
  {
    companyId: '6735c53c41a2fc6b29e17f8f',
    Feedback: {
      label: 'Submit Feedback',
      shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
      description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'

  },

  {
    companyId: '68a6b99cb6d453599f2f47ad',
    Feedback: {
      label: 'Submit Feedback',
      shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
      description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'

  },

  {
    companyId: null,
    // Feedback: {
    //   label: 'Submit Feedback',
    //   shortLabel: null,
    //   description: null
    // },
    Complaint: {
      label: 'Raise Ticket',
      shortLabel:'Ticket',
      description:'Kindly raise your ticket with us. We will do our best to resolve them.'
    },
    backgroundImage: null //'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'

  },
  {
    companyId: '69f0a5bde0ce4044fdfa3ba6', //live Mammoth
    Feedback: {
      label: 'Submit Feedback',
     shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
       description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/58af6b0cb134d6125ee284bb73ab3014_YGLY6k8GM.png'
  },
  {
    companyId: '69f99d7db7f6c3a530b40421', //test Mammoth
    Feedback: {
      label: 'Submit Feedback',
     shortLabel: null,
      description: null
    },
    Complaint: {
      label: 'Submit Maintenance Request',
      shortLabel:'Maintenance Request',
       description:'Kindly submit your maintenance request with us. We will do our best to resolve them.'
    },
    backgroundImage: 'https://ik.imagekit.io/qdesq/qdesq/64eef35fa42349d600ac80d02fae5af9_k_KbhXKtTp.jpg'
  },
]

  let labelSetting = FeedbackAndComplaintsUserFlowCustomizations.find(item => item.companyId === localStorage.getItem('companyId'));

export const SideMenuList = [
    {
      name : 'Meeting Room & Desk',    // change name with precuation--- do search name  in all files before changing 
      selected : false ,
      disabled:false,
      hidden:true,
      sublist : [{
        name: 'Analytics',
        selected: false,
        disabled:false,
        hidden:false,
        url: 'analytics',
        fullUrl:'/admin-dash/analytics',
        title:'Analytical Insights | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Qr Codes',
        selected : false ,
        url : 'qr-codes',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/qr-codes',
        title:'Office and floors QR Codes | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Bookings',
        selected : false ,
        url : 'booking',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/booking',
        title:'Bookings Overview | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Logs',
        selected : false ,
        url : 'logs',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/logs',
        title:'Booking Logs | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Disable',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'disable',
        fullUrl:'/admin-dash/disable',
        title:'Disable User Screen | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Booking Approval',
        selected : false ,
        url : 'booking-approval',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/booking-approval',
        title:'Approval based Bookings | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Usage Matrix',
        selected : false ,
        url : 'meeting-room-usage-matrix',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/meeting-room-usage-matrix',
        title:'Usage Matrix | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Update Inventory', // change name with precuation--- do search name  in all files before changing 
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'edit-meeting-rooms-details',
        fullUrl:'/admin-dash/edit-meeting-rooms-details',
        title:"Add and edit your meeting rooms inventory | ${companyName}| India's No. 1 Enterprise SaaS"
      },
      ],
      productCode : 1,
      type:'product',
      icon:'https://ik.imagekit.io/qdesq/df7c8b9dc93438ca4691813a8c22339a_MwnzDkSj3.png'
    },
    {
      name : 'Check-In Management',  // change name with precuation--- do search name  in all files before changing 
      selected : false ,
      hidden:true,
      sublist : [{
        name : 'Analytics',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-analytics',
        fullUrl:'/admin-dash/checkin-analytics',
        title:'Analytical Insights | ${companyName} | Visitor Management System'
      },{
        name : 'Qr Codes',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-qr-codes',
        fullUrl:'/admin-dash/checkin-qr-codes',
        title:''
      },{
        name : 'Logs',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-logs',
        fullUrl:'/admin-dash/checkin-logs',
        title:'Check-in and check-out Logs  | ${companyName} | Visitor Management System'
      },
      {
        name : 'Visitor’s List',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'visitor-details',
        fullUrl:'/admin-dash/visitor-details',
        title:'Unique Visitors Details | ${companyName} | Visitor Management System'
      },{
        name : 'Blacklist',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'blacklist',
        fullUrl:'/admin-dash/blacklist',
        title:'Blacklist Visitors | ${companyName} | Visitor Management System'
      },
      // {
      //   name : 'Invite Logs',
      //   selected : false ,
      //   url : 'prebooking-logs',
      //   disabled:false,
      //   hidden:false,
      //   fullUrl:'/admin-dash/prebooking-logs'
      // }
      {
        name : 'Pre Invites',
        selected : false ,
        // url : 'prebooking-logs',
        disabled:false,
        hidden:false,
        // fullUrl:'/admin-dash/prebooking-logs'
        sublist:[
          {
            name : 'Send Invites',
            selected : false ,
            url : 'check-in-prebooking',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/check-in-prebooking',
            title:'Invite Guests | ${companyName} | Visitor Management System'
          },
          {
            name : 'Single Day Logs',
            selected : false ,
            url : 'prebooking-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/prebooking-logs',
            title:'Single Day Invite Logs | ${companyName} |  Visitor Management System'
          },
          {
            name : 'Long Term Logs',
            selected : false ,
            url : 'long-term-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/long-term-logs',
            title:'Multiple Day Invite Logs | ${companyName}  | Visitor Management System'
          }
        ]
      },
      {
        name : 'Visitor Approval',
        selected : false ,
        url : 'visitor-approval-requests',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/visitor-approval-requests',
        title:'Approve your visitors | ${companyName} | Visitor Management System'
      },
      {
        name : 'Approval Matrix',
        selected : false ,
        url : 'approval-matrix',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/approval-matrix',
        title:'Approve your visitors | ${companyName} | Visitor Management System'
      },
      {
        name : 'Check-In Details', // change name with precuation--- do search name  in all files before changing 
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'edit-visitor-checkin-details',
        fullUrl:'/admin-dash/edit-visitor-checkin-details',
        title:"Add and edit your visitor management details  | ${companyName}  | India's No. 1 Enterprise SaaS"
      },
      ],
      productCode:2,
      type:'product',
      icon:'https://ik.imagekit.io/qdesq/0af8a1f9ec44d6743e8f2366c43fe47c_c8VKZw-c_.png'
    },
    {
      name : 'Feedback & Complaints', 
      selected : false ,
      sublist : [{
        name : 'Qr Codes',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/qr-codes',
        fullUrl:'/admin-dash/feedback-and-complaints/qr-codes',
        title:'${companyName} | Feedback and Compliant Box'
      },
      {
        name : 'Analytics',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/analytics',
        fullUrl:'/admin-dash/feedback-and-complaints/analytics',
        title:'Analytical insights | ${companyName}  | Feedback & Complaint Box'
      },
      {
        name : 'Logs ',
        selected : false ,
        disabled:false,
        hidden:false,
        id:'product3Logs',
        sublist:[
          {
            name : 'Feedback logs',
            selected : false ,
            url : 'feedback-and-complaints/feedback-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/feedback-logs',
            title:'My Logs | ${companyName}  | Feedback & Complaint Box',
            productCode:3
          },
          {
            name : `${labelSetting?.Complaint?.shortLabel || 'Ticket'} logs`,
            selected : false ,
            url : 'feedback-and-complaints/complaint-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/complaint-logs',
            title:'My Logs | ${companyName}  | Feedback & Complaint Box',
            productCode:4
          },
        ]
      },
      {
        name : 'Work-flow Settings',
        selected : false ,
        disabled:false,
        hidden:false,
        sublist:[
          {
            name : 'Feedback',
            selected : false ,
            url : 'feedback-and-complaints/feedback-settings',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/feedback-settings',
            title:'Customisable forms | ${companyName} | Feedback & Complaint Box',
            productCode:3
          },
          {
            name : `${labelSetting?.Complaint?.shortLabel || 'Tickets'}`,
            selected : false ,
            url : 'feedback-and-complaints/complaint-settings',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/complaint-settings',
            title:'Customisable forms | ${companyName} | Feedback & Complaint Box',
            productCode:4
          },
        ]
      },
      {
        name : 'Auditors',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/auditors',
        fullUrl:'/admin-dash/feedback-and-complaints/auditors',
        title:'Auditors | ${companyName}  | Feedback & Complaint Box'
      },
      ],
      productCode:3,
      type:'product',
      hidden: true,
      icon:'https://ik.imagekit.io/qdesq/fcbf0e5a7d26c1a8bdb8da91ed5faf85_shc3AwTyY.png'
    },
    {
      name : 'User Roles',
      selected : false ,
      sublist : [
        {
          name : 'Office Admins',
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'admins',
          fullUrl:'/admin-dash/admins',
          title:"Admins List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Tenant Admins',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:true,
          url : 'tenant-admins',
          fullUrl:'/admin-dash/tenant-admins',
          title:"Tenant Admins List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Supervisor',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'supervisor',
          fullUrl:'/admin-dash/supervisor',
          title:"Supervisors | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Verification Team',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'security-team',
          fullUrl:'/admin-dash/security-team',
          title:"Verification Team List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        }
      ],
      icon:'https://ik.imagekit.io/qdesq/83d9d40c8afc0fcc6aee58eaff468f90_q4IENt3QB.png'
    },
    {
      name:'Employees',
      selected: false,
      sublist: [
        {
          name : 'Employee List',
          selected : false ,
          url : 'employees',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/employees',
          title:"Employee List | ${companyName} | India's No. 1 Enterprise SaaS"
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/e15436abdb1871255d65774bfac30c45_s8uY5glCJ.png'
    },
    {
      name:'Activity Logs',
      selected: false,
      url : 'activity-logs',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/activity-logs',
      title:"Activity Logs | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/qdesq/c64a7e14a19f365328eb23988766630c_XocvG_Owy.svg'
    },
    {
      name:'Account Settings',
      selected: false,
      disabled:false,
      hidden:true,
      icon:'https://ik.imagekit.io/qdesq/83cc0e1d9d3600c2cca99ad7ee42b27a_xJSxgxVYS.png',
       sublist: [
       
          {
            name : 'Product Details',
            selected : false ,
            url : 'account-settings',
            disabled:false,
            hidden:true,
            fullUrl:'/admin-dash/account-settings',
            title:"Account Settings | ${companyName} |  India's No. 1 Enterprise SaaS",
          },
          {
            name : 'Organization Details',
            selected : false ,
            disabled:false,
            hidden:true,
            url : 'edit-organization-details',
            fullUrl:'/admin-dash/edit-organization-details',
            title:"Organisation Details | ${companyName} | India's No. 1 Enterprise SaaS"
          },
      ],
    },
    {
      name:'Attendance',
      selected: false,
      hidden:true,
      sublist: [
        {
          name : 'Employee Logs',
          selected : false ,
          url : 'employee-logs',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/employee-logs'
        },
        {
          name : 'Attendance Report',
          selected : false ,
          url : 'attendance-report',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/attendance-report'
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/aef1b81244dd4fcc6e0df8b5c26f0b32_3hrzlit1y.png'
    },
    {
      name:'Broadcast Message',
      selected: false,
      hidden: true,
      sublist: [
        {
          name : 'Send Message',
          selected : false ,
          url : 'broadcast/send',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/send'
        },
        {
          name : 'Message Logs',
          selected : false ,
          url : 'broadcast/logs',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/logs'
        },
        {
          name : 'My Wallet',
          selected : false ,
          url : 'broadcast/wallet',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/wallet'
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/b09dda0383c41b9fcdf257f612101d3f_sOndJHc7H5.png'
    },
    // {
    //   name : 'Edit',
    //   selected : false ,
    //   disabled:false,
    //   hidden:false,
    //   sublist : [{
    //     name : 'Organization Details', // change name with precuation--- do search name  in all files before changing 
    //     selected : false ,
    //     disabled:false,
    //     hidden:false,
    //     url : 'edit-organization-details',
    //     fullUrl:'/admin-dash/edit-organization-details',
    //     title:"Organisation Details | ${companyName} | India's No. 1 Enterprise SaaS"
    //   },
     
      

    //   ],
    //   icon:'https://ik.imagekit.io/qdesq/e76204e0e67752603bc332bd582a984f_6zFyMb08C.png'
    // },

    {
      name:'Policies & Compliance',
      selected: false,
      url : 'policies-compliance',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/policies-compliance',
      title:"Policies & Compliance | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/qdesq/2c62977d0ecc0be2877b2012d276c6c9_j_XkADV_1O.svg',
      forAll: true
    },
    {
      name:'Help Desk',
      selected: false,
      url : 'support',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/support',
      title:"Help Desk | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/be562f7a70ea9a8adf748c8b93a0e7cd_M-E7A1mmi.png',
      forAll: true
    },
    
  ]

  export const getSideMenuList = () => {

  let labelSetting = FeedbackAndComplaintsUserFlowCustomizations.find(item => item.companyId === localStorage.getItem('companyId'));

  console.log('labelSetting--1-1---commondata-',labelSetting)

    
  return  [
    {
      name : 'Meeting Room & Desk',    // change name with precuation--- do search name  in all files before changing 
      selected : false ,
      disabled:false,
      hidden:true,
      sublist : [
        {
          name: 'Book a Room',
          selected: false,
          disabled:false,
          hidden:true,
          url: 'book-meeting-rooms',
          fullUrl:'/employee-dash/book-meeting-rooms',
          title:'Book A Room | ${companyName} | Meeting Room Booking Interface',
          roles:['Employee'],
          id:'book-meeting-rooms'
        },
        {
          name: 'My Bookings',
          selected: false,
          disabled:false,
          hidden:true,
          url: 'my-bookings',
          fullUrl:'/employee-dash/my-bookings',
          title:'My Bookings | ${companyName} | Meeting Room Booking Interface',
          roles:['Employee'],
          id:'my-bookings'
        },
        {
        name: 'Analytics',
        selected: false,
        disabled:false,
        hidden:false,
        url: 'analytics',
        fullUrl:'/admin-dash/analytics',
        title:'Analytical Insights | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Qr Codes',
        selected : false ,
        url : 'qr-codes',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/qr-codes',
        title:'Office and floors QR Codes | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Bookings',
        selected : false ,
        url : 'booking',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/booking',
        title:'Bookings Overview | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Logs',
        selected : false ,
        url : 'logs',
        disabled:false,
        hidden:false,
        fullUrl:'/admin-dash/logs',
        title:'Booking Logs | ${companyName} | Meeting Room Booking Interface'
      },{
        name : 'Disable',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'disable',
        fullUrl:'/admin-dash/disable',
        title:'Disable User Screen | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Booking Approval',
        selected : false ,
        url : 'booking-approval',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/booking-approval',
        title:'Approval based Bookings | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Usage Matrix',
        selected : false ,
        url : 'meeting-room-usage-matrix',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/meeting-room-usage-matrix',
        title:'Usage Matrix | ${companyName} | Meeting Room Booking Interface'
      },
      {
        name : 'Update Inventory', // change name with precuation--- do search name  in all files before changing 
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'edit-meeting-rooms-details',
        fullUrl:'/admin-dash/edit-meeting-rooms-details',
        title:"Add and edit your meeting rooms inventory | ${companyName}| India's No. 1 Enterprise SaaS"
      },
      ],
      productCode : 1,
      type:'product',
      icon:'https://ik.imagekit.io/qdesq/df7c8b9dc93438ca4691813a8c22339a_MwnzDkSj3.png'
    },
    {
      name : 'Check-In Management',  // change name with precuation--- do search name  in all files before changing 
      selected : false ,
      hidden:true,
      sublist : [{
        name : 'Analytics',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-analytics',
        fullUrl:'/admin-dash/checkin-analytics',
        title:'Analytical Insights | ${companyName} | Visitor Management System'
      },{
        name : 'Qr Codes',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-qr-codes',
        fullUrl:'/admin-dash/checkin-qr-codes',
        title:''
      },{
        name : 'Logs',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'checkin-logs',
        fullUrl:'/admin-dash/checkin-logs',
        title:'Check-in and check-out Logs  | ${companyName} | Visitor Management System',
        roles:['Employee','Admin','Super Admin','Supervisor','Auditor']
      },
      {
        name : 'Visitor’s List',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'visitor-details',
        fullUrl:'/admin-dash/visitor-details',
        title:'Unique Visitors Details | ${companyName} | Visitor Management System'
      },{
        name : 'Blacklist',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'blacklist',
        fullUrl:'/admin-dash/blacklist',
        title:'Blacklist Visitors | ${companyName} | Visitor Management System'
      },
      // {
      //   name : 'Invite Logs',
      //   selected : false ,
      //   url : 'prebooking-logs',
      //   disabled:false,
      //   hidden:false,
      //   fullUrl:'/admin-dash/prebooking-logs'
      // }
      {
        name : 'Pre Invites',
        selected : false ,
        // url : 'prebooking-logs',
        disabled:false,
        hidden:false,
        // fullUrl:'/admin-dash/prebooking-logs',
        roles:['Employee','Admin','Super Admin','Supervisor','Auditor'],
        sublist:[
          {
            name : 'Send Invites',
            selected : false ,
            url : 'check-in-prebooking',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/check-in-prebooking',
            title:'Invite Guests | ${companyName} | Visitor Management System'
          },
          {
            name : 'Single Day Logs',
            selected : false ,
            url : 'prebooking-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/prebooking-logs',
            title:'Single Day Invite Logs | ${companyName} |  Visitor Management System'
          },
          {
            name : 'Long Term Logs',
            selected : false ,
            url : 'long-term-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/long-term-logs',
            title:'Multiple Day Invite Logs | ${companyName}  | Visitor Management System'
          }
        ]
      },
      {
        name : 'Visitor Approval',
        selected : false ,
        url : 'visitor-approval-requests',
        disabled:false,
        hidden:true,
        roles:['Employee','Admin','Super Admin','Supervisor','Auditor'],
        fullUrl:'/admin-dash/visitor-approval-requests',
        title:'Approve your visitors | ${companyName} | Visitor Management System'
      },
      {
        name : 'Approval Matrix',
        selected : false ,
        url : 'approval-matrix',
        disabled:false,
        hidden:true,
        fullUrl:'/admin-dash/approval-matrix',
        title:'Approve your visitors | ${companyName} | Visitor Management System'
      },
      {
        name : 'Check-In Details', // change name with precuation--- do search name  in all files before changing 
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'edit-visitor-checkin-details',
        fullUrl:'/admin-dash/edit-visitor-checkin-details',
        title:"Add and edit your visitor management details  | ${companyName}  | India's No. 1 Enterprise SaaS"
      },
      ],
      productCode:2,
      type:'product',
      icon:'https://ik.imagekit.io/qdesq/0af8a1f9ec44d6743e8f2366c43fe47c_c8VKZw-c_.png'
    },
    {
      name : 'Feedback & Complaints', 
      selected : false ,
      sublist : [{
        name : 'Qr Codes',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/qr-codes',
        fullUrl:'/admin-dash/feedback-and-complaints/qr-codes',
        title:'${companyName} | Feedback and Compliant Box'
      },
      {
        name : 'Analytics',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/analytics',
        fullUrl:'/admin-dash/feedback-and-complaints/analytics',
        title:'Analytical insights | ${companyName}  | Feedback & Complaint Box'
      },
      {
        name : 'Logs ',
        selected : false ,
        disabled:false,
        hidden:false,
        id:'product3Logs',
        roles:['Employee','Admin','Super Admin','Supervisor','Auditor'],
        sublist:[
          {
            name : 'Feedback logs',
            selected : false ,
            url : 'feedback-and-complaints/feedback-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/feedback-logs',
            title:'My Logs | ${companyName}  | Feedback & Complaint Box',
            productCode:3
          },
          {
            name : `${labelSetting?.Complaint?.shortLabel || 'Ticket'} logs`,
            selected : false ,
            url : 'feedback-and-complaints/complaint-logs',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/complaint-logs',
            title:'My Logs | ${companyName}  | Feedback & Complaint Box',
            productCode:4
          },
        ]
      },
      {
        name : 'Work-flow Settings',
        selected : false ,
        disabled:false,
        hidden:false,
        sublist:[
          {
            name : 'Feedback',
            selected : false ,
            url : 'feedback-and-complaints/feedback-settings',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/feedback-settings',
            title:'Customisable forms | ${companyName} | Feedback & Complaint Box',
            productCode:3
          },
          {
            name : `${labelSetting?.Complaint?.shortLabel || 'Tickets'}`,
            selected : false ,
            url : 'feedback-and-complaints/complaint-settings',
            disabled:false,
            hidden:false,
            fullUrl:'/admin-dash/feedback-and-complaints/complaint-settings',
            title:'Customisable forms | ${companyName} | Feedback & Complaint Box',
            productCode:4
          },
        ]
      },
      {
        name : 'Auditors',
        selected : false ,
        disabled:false,
        hidden:false,
        url : 'feedback-and-complaints/auditors',
        fullUrl:'/admin-dash/feedback-and-complaints/auditors',
        title:'Auditors | ${companyName}  | Feedback & Complaint Box'
      },
      ],
      productCode:3,
      type:'product',
      hidden: true,
      icon:'https://ik.imagekit.io/qdesq/fcbf0e5a7d26c1a8bdb8da91ed5faf85_shc3AwTyY.png'
    },
    {
      name : 'User Roles',
      selected : false ,
      sublist : [
        {
          name : 'Office Admins',
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'admins',
          fullUrl:'/admin-dash/admins',
          title:"Admins List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Tenant Admins',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:true,
          url : 'tenant-admins',
          fullUrl:'/admin-dash/tenant-admins',
          title:"Tenant Admins List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Supervisor',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'supervisor',
          fullUrl:'/admin-dash/supervisor',
          title:"Supervisors | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        },
        {
          name : 'Verification Team',   // change name with precuation--- do search name  in all files before changing 
          selected : false ,
          disabled:false,
          hidden:false,
          url : 'security-team',
          fullUrl:'/admin-dash/security-team',
          title:"Verification Team List | ${companyName} | Qudify | India's No. 1 Enterprise SaaS"
        }
      ],
      icon:'https://ik.imagekit.io/qdesq/83d9d40c8afc0fcc6aee58eaff468f90_q4IENt3QB.png'
    },
    {
      name:'Employees',
      selected: false,
      sublist: [
        {
          name : 'Employee List',
          selected : false ,
          url : 'employees',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/employees',
          title:"Employee List | ${companyName} | India's No. 1 Enterprise SaaS"
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/e15436abdb1871255d65774bfac30c45_s8uY5glCJ.png'
    },
    {
      name:'Activity Logs',
      selected: false,
      url : 'activity-logs',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/activity-logs',
      title:"Activity Logs | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/qdesq/c64a7e14a19f365328eb23988766630c_XocvG_Owy.svg'
    },
    {
      name:'Account Settings',
      selected: false,
      disabled:false,
      hidden:true,
      icon:'https://ik.imagekit.io/qdesq/83cc0e1d9d3600c2cca99ad7ee42b27a_xJSxgxVYS.png',
       sublist: [
       
          {
            name : 'Product Details',
            selected : false ,
            url : 'account-settings',
            disabled:false,
            hidden:true,
            fullUrl:'/admin-dash/account-settings',
            title:"Account Settings | ${companyName} |  India's No. 1 Enterprise SaaS",
          },
          {
            name : 'Organization Details',
            selected : false ,
            disabled:false,
            hidden:true,
            url : 'edit-organization-details',
            fullUrl:'/admin-dash/edit-organization-details',
            title:"Organisation Details | ${companyName} | India's No. 1 Enterprise SaaS"
          },
      ],
    },
    {
      name:'Attendance',
      selected: false,
      hidden:true,
      sublist: [
        {
          name : 'Employee Logs',
          selected : false ,
          url : 'employee-logs',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/employee-logs'
        },
        {
          name : 'Attendance Report',
          selected : false ,
          url : 'attendance-report',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/attendance-report'
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/aef1b81244dd4fcc6e0df8b5c26f0b32_3hrzlit1y.png'
    },
    {
      name:'Broadcast Message',
      selected: false,
      hidden: true,
      sublist: [
        {
          name : 'Send Message',
          selected : false ,
          url : 'broadcast/send',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/send'
        },
        {
          name : 'Message Logs',
          selected : false ,
          url : 'broadcast/logs',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/logs'
        },
        {
          name : 'My Wallet',
          selected : false ,
          url : 'broadcast/wallet',
          disabled:false,
          hidden:false,
          fullUrl:'/admin-dash/broadcast/wallet'
        },
      ],
      icon:'https://ik.imagekit.io/qdesq/b09dda0383c41b9fcdf257f612101d3f_sOndJHc7H5.png'
    },
    // {
    //   name : 'Edit',
    //   selected : false ,
    //   disabled:false,
    //   hidden:false,
    //   sublist : [{
    //     name : 'Organization Details', // change name with precuation--- do search name  in all files before changing 
    //     selected : false ,
    //     disabled:false,
    //     hidden:false,
    //     url : 'edit-organization-details',
    //     fullUrl:'/admin-dash/edit-organization-details',
    //     title:"Organisation Details | ${companyName} | India's No. 1 Enterprise SaaS"
    //   },
     
      

    //   ],
    //   icon:'https://ik.imagekit.io/qdesq/e76204e0e67752603bc332bd582a984f_6zFyMb08C.png'
    // },

    {
      name:'Policies & Compliance',
      selected: false,
      url : 'policies-compliance',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/policies-compliance',
      title:"Policies & Compliance | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/qdesq/2c62977d0ecc0be2877b2012d276c6c9_j_XkADV_1O.svg',
      forAll: true
    },
    {
      name:'Help Desk',
      selected: false,
      url : 'support',
      disabled:false,
      hidden:false,
      fullUrl:'/admin-dash/support',
      title:"Help Desk | ${companyName} |  India's No. 1 Enterprise SaaS",
      icon:'https://ik.imagekit.io/qdesq/be562f7a70ea9a8adf748c8b93a0e7cd_M-E7A1mmi.png',
      forAll: true
    },
    
  ]


  }

  export const getSideMenuListForEmployees = () => {

    let allMenuList = JSON.parse(JSON.stringify(getSideMenuList()));

    allMenuList = allMenuList.filter(item => item.productCode == 1 || item.productCode == 2 || item.productCode == 3 || item.productCode == 4);

    allMenuList.forEach(productMenu => {
      
      if(productMenu.sublist?.length){

          productMenu.sublist = productMenu.sublist.filter(menu => menu['roles']?.includes('Employee')) as any;

          productMenu.sublist?.forEach(sublist => {
            sublist.hidden = false;
            sublist.fullUrl = sublist.fullUrl ? sublist.fullUrl.replace('/admin-dash', '/employee-dash') : null;

            if(sublist.sublist?.length){    

              sublist.sublist?.forEach(subSubList => {
                subSubList.hidden = false;
                subSubList.fullUrl = subSubList.fullUrl ? subSubList.fullUrl.replace('/admin-dash', '/employee-dash') : null;
              })
            }

          });

      }

    })

    return allMenuList;


  }

export const Time = [
  { hour:'0', min:'0', displayTime:'12 AM Morning', value:0},
  { hour:'0', min:'30', displayTime:'12:30 AM', value:30},
  { hour:'1', min:'00', displayTime:'1:00 AM', value:100},
  { hour:'1', min:'30', displayTime:'1:30 AM', value:130},
  { hour:'2', min:'00', displayTime:'2:00 AM',value:200},
  { hour:'2', min:'30', displayTime:'2:30 AM',value:230},
  { hour:'3', min:'00', displayTime:'3:00 AM',value:300},
  { hour:'3', min:'30', displayTime:'3:30 AM',value:330},
  { hour:'4', min:'00', displayTime:'4:00 AM', value:400},
  { hour:'4', min:'30', displayTime:'4:30 AM', value:430},
  { hour:'5', min:'00', displayTime:'5:00 AM', value:500},
  { hour:'5', min:'30', displayTime:'5:30 AM',value:530},
  { hour:'6', min:'00', displayTime:'6:00 AM', value:600},
  { hour:'6', min:'30', displayTime:'6:30 AM', value:630},
  { hour:'7', min:'00', displayTime:'7:00 AM', value:700},
  { hour:'7', min:'30', displayTime:'7:30 AM', value:730},
  { hour:'8', min:'00', displayTime:'8:00 AM',value:800},
  { hour:'8', min:'30', displayTime:'8:30 AM',value:830},
  { hour:'9', min:'00', displayTime:'9:00 AM',value:900},
  { hour:'9', min:'30', displayTime:'9:30 AM',value:930},
  { hour:'10', min:'00', displayTime:'10:00 AM',value:1000},
  { hour:'10', min:'30', displayTime:'10:30 AM',value:1030},
  { hour:'11', min:'00', displayTime:'11:00 AM',value:1100},
  { hour:'11', min:'30', displayTime:'11:30 AM',value:1130},
  { hour:'12', min:'00', displayTime:'12:00 PM',value:1200},
  { hour:'12', min:'30', displayTime:'12:30 PM',value:1230},
  { hour:'13', min:'00', displayTime:'1:00 PM',value:1300},
  { hour:'13', min:'30', displayTime:'1:30 PM',value:1330},
  { hour:'14', min:'00', displayTime:'2:00 PM',value:1400},
  { hour:'14', min:'30', displayTime:'2:30 PM',value:1430},
  { hour:'15', min:'00', displayTime:'3:00 PM',value:1500},
  { hour:'15', min:'30', displayTime:'3:30 PM',value:1530},
  { hour:'16', min:'00', displayTime:'4:00 PM',value:1600},
  { hour:'16', min:'30', displayTime:'4:30 PM',value:1630},
  { hour:'17', min:'00', displayTime:'5:00 PM',value:1700},
  { hour:'17', min:'30', displayTime:'5:30 PM',value:1730},
  { hour:'18', min:'00', displayTime:'6:00 PM',value:1800},
  { hour:'18', min:'30', displayTime:'6:30 PM',value:1830},
  { hour:'19', min:'00', displayTime:'7:00 PM',value:1900},
  { hour:'19', min:'30', displayTime:'7:30 PM',value:1930},
  { hour:'20', min:'00', displayTime:'8:00 PM',value:2000},
  { hour:'20', min:'30', displayTime:'8:30 PM',value:2030},
  { hour:'21', min:'00', displayTime:'9:00 PM',value:2100},
  { hour:'21', min:'30', displayTime:'9:30 PM',value:2130},
  { hour:'22', min:'00', displayTime:'10:00 PM',value:2200},
  { hour:'22', min:'30', displayTime:'10:30 PM',value:2230},
  { hour:'23', min:'00', displayTime:'11:00 PM',value:2300},
  { hour:'23', min:'30', displayTime:'11:30 PM',value:2330},
  { hour:'24', min:'00', displayTime:'12 AM Night',value:2400},
]
export const TimeOptionsForPreInvite = [
  { hour:'0', min:'0', displayTime:'0:00 AM', value:0},
  { hour:'0', min:'30', displayTime:'0:30 AM', value:30},
  { hour:'1', min:'00', displayTime:'1:00 AM', value:100},
  { hour:'1', min:'30', displayTime:'1:30 AM', value:130},
  { hour:'2', min:'00', displayTime:'2:00 AM',value:200},
  { hour:'2', min:'30', displayTime:'2:30 AM',value:230},
  { hour:'3', min:'00', displayTime:'3:00 AM',value:300},
  { hour:'3', min:'30', displayTime:'3:30 AM',value:330},
  { hour:'4', min:'00', displayTime:'4:00 AM', value:400},
  { hour:'4', min:'30', displayTime:'4:30 AM', value:430},
  { hour:'5', min:'00', displayTime:'5:00 AM', value:500},
  { hour:'5', min:'30', displayTime:'5:30 AM',value:530},
  { hour:'6', min:'00', displayTime:'6:00 AM', value:600},
  { hour:'6', min:'30', displayTime:'6:30 AM', value:630},
  { hour:'7', min:'00', displayTime:'7:00 AM', value:700},
  { hour:'7', min:'30', displayTime:'7:30 AM', value:730},
  { hour:'8', min:'00', displayTime:'8:00 AM',value:800},
  { hour:'8', min:'30', displayTime:'8:30 AM',value:830},
  { hour:'9', min:'00', displayTime:'9:00 AM',value:900},
  { hour:'9', min:'30', displayTime:'9:30 AM',value:930},
  { hour:'10', min:'00', displayTime:'10:00 AM',value:1000},
  { hour:'10', min:'30', displayTime:'10:30 AM',value:1030},
  { hour:'11', min:'00', displayTime:'11:00 AM',value:1100},
  { hour:'11', min:'30', displayTime:'11:30 AM',value:1130},
  { hour:'12', min:'00', displayTime:'12:00 Noon',value:1200},
  { hour:'12', min:'30', displayTime:'12:30 PM',value:1230},
  { hour:'13', min:'00', displayTime:'1:00 PM',value:1300},
  { hour:'13', min:'30', displayTime:'1:30 PM',value:1330},
  { hour:'14', min:'00', displayTime:'2:00 PM',value:1400},
  { hour:'14', min:'30', displayTime:'2:30 PM',value:1430},
  { hour:'15', min:'00', displayTime:'3:00 PM',value:1500},
  { hour:'15', min:'30', displayTime:'3:30 PM',value:1530},
  { hour:'16', min:'00', displayTime:'4:00 PM',value:1600},
  { hour:'16', min:'30', displayTime:'4:30 PM',value:1630},
  { hour:'17', min:'00', displayTime:'5:00 PM',value:1700},
  { hour:'17', min:'30', displayTime:'5:30 PM',value:1730},
  { hour:'18', min:'00', displayTime:'6:00 PM',value:1800},
  { hour:'18', min:'30', displayTime:'6:30 PM',value:1830},
  { hour:'19', min:'00', displayTime:'7:00 PM',value:1900},
  { hour:'19', min:'30', displayTime:'7:30 PM',value:1930},
  { hour:'20', min:'00', displayTime:'8:00 PM',value:2000},
  { hour:'20', min:'30', displayTime:'8:30 PM',value:2030},
  { hour:'21', min:'00', displayTime:'9:00 PM',value:2100},
  { hour:'21', min:'30', displayTime:'9:30 PM',value:2130},
  { hour:'22', min:'00', displayTime:'10:00 PM',value:2200},
  { hour:'22', min:'30', displayTime:'10:30 PM',value:2230},
  { hour:'23', min:'00', displayTime:'11:00 PM',value:2300},
  { hour:'23', min:'30', displayTime:'11:30 PM',value:2330},
  { hour:'24', min:'00', displayTime:'12 AM Night',value:2400},
]
export const CountryCode =   [
  {
  name: "Afghanistan",
  dialCode: "93",
  code: "AF"
  },
  {
  name: "Aland Islands",
  dialCode: "358",
  code: "AX"
  },
  {
  name: "Albania",
  dialCode: "355",
  code: "AL"
  },
  {
  name: "Algeria",
  dialCode: "213",
  code: "DZ"
  },
  {
  name: "AmericanSamoa",
  dialCode: "1684",
 code: "AS"
  },
  {
  name: "Andorra",
  dialCode: "376",
  code: "AD"
  },
  {
  name: "Angola",
  dialCode: "244",
  code: "AO"
  },
  {
  name: "Anguilla",
  dialCode: "1264",
  code: "AI"
  },
  {
  name: "Antarctica",
  dialCode: "672",
  code: "AQ"
  },
  {
  name: "Antigua and Barbuda",
  dialCode: "1268",
  code: "AG"
  },
  {
  name: "Argentina",
  dialCode: "54",
  code: "AR"
  },
  {
  name: "Armenia",
  dialCode: "374",
  code: "AM"
  },
  {
  name: "Aruba",
  dialCode: "297",
  code: "AW"
  },
  {
  name: "Australia",
  dialCode: "61",
  code: "AU"
  },
  {
  name: "Austria",
  dialCode: "43",
  code: "AT"
  },
  {
  name: "Azerbaijan",
  dialCode: "994",
  code: "AZ"
  },
  {
  name: "Bahamas",
  dialCode: "1242",
  code: "BS"
  },
  {
  name: "Bahrain",
  dialCode: "973",
  code: "BH"
  },
  {
  name: "Bangladesh",
  dialCode: "880",
  code: "BD"
  },
  {
  name: "Barbados",
  dialCode: "1246",
  code: "BB"
  },
  {
  name: "Belarus",
  dialCode: "375",
  code: "BY"
  },
  {
  name: "Belgium",
  dialCode: "32",
  code: "BE"
  },
  {
  name: "Belize",
  dialCode: "501",
  code: "BZ"
  },
  {
  name: "Benin",
  dialCode: "229",
  code: "BJ"
  },
  {
  name: "Bermuda",
  dialCode: "1441",
  code: "BM"
  },
  {
  name: "Bhutan",
  dialCode: "975",
  code: "BT"
  },
  {
  name: "Bolivia, Plurinational State of",
  dialCode: "591",
  code: "BO"
  },
  {
  name: "Bosnia and Herzegovina",
  dialCode: "387",
  code: "BA"
  },
  {
  name: "Botswana",
  dialCode: "267",
  code: "BW"
  },
  {
  name: "Brazil",
  dialCode: "55",
  code: "BR"
  },
  {
  name: "British Indian Ocean Territory",
  dialCode: "246",
  code: "IO"
  },
  {
  name: "Brunei Darussalam",
  dialCode: "673",
  code: "BN"
  },
  {
  name: "Bulgaria",
  dialCode: "359",
  code: "BG"
  },
  {
  name: "Burkina Faso",
  dialCode: "226",
  code: "BF"
  },
  {
  name: "Burundi",
  dialCode: "257",
  code: "BI"
  },
  {
  name: "Cambodia",
  dialCode: "855",
  code: "KH"
  },
  {
  name: "Cameroon",
  dialCode: "237",
  code: "CM"
  },
  {
  name: "Canada",
  dialCode: "1",
  code: "CA"
  },
  {
  name: "Cape Verde",
  dialCode: "238",
  code: "CV"
  },
  {
  name: "Cayman Islands",
  dialCode: "345",
  code: "KY"
  },
  {
  name: "Central African Republic",
  dialCode: "236",
  code: "CF"
  },
  {
  name: "Chad",
  dialCode: "235",
  code: "TD"
  },
  {
  name: "Chile",
  dialCode: "56",
  code: "CL"
  },
  {
  name: "China",
  dialCode: "86",
  code: "CN"
  },
  {
  name: "Christmas Island",
  dialCode: "61",
  code: "CX"
  },
  {
  name: "Cocos (Keeling) Islands",
  dialCode: "61",
  code: "CC"
  },
  {
  name: "Colombia",
  dialCode: "57",
  code: "CO"
  },
  {
  name: "Comoros",
  dialCode: "269",
  code: "KM"
  },
  {
  name: "Congo",
  dialCode: "242",
  code: "CG"
  },
  {
  name: "Congo, The Democratic Republic of the Congo",
  dialCode: "243",
  code: "CD"
  },
  {
  name: "Cook Islands",
  dialCode: "682",
  code: "CK"
  },
  {
  name: "Costa Rica",
  dialCode: "506",
  code: "CR"
  },
  {
  name: "Cote d'Ivoire",
  dialCode: "225",
  code: "CI"
  },
  {
  name: "Croatia",
  dialCode: "385",
  code: "HR"
  },
  {
  name: "Cuba",
  dialCode: "53",
  code: "CU"
  },
  {
  name: "Cyprus",
  dialCode: "357",
  code: "CY"
  },
  {
  name: "Czech Republic",
  dialCode: "420",
  code: "CZ"
  },
  {
  name: "Denmark",
  dialCode: "45",
  code: "DK"
  },
  {
  name: "Djibouti",
  dialCode: "253",
  code: "DJ"
  },
  {
  name: "Dominica",
  dialCode: "1767",
  code: "DM"
  },
  {
  name: "Dominican Republic",
  dialCode: "1849",
  code: "DO"
  },
  {
  name: "Ecuador",
  dialCode: "593",
  code: "EC"
  },
  {
  name: "Egypt",
  dialCode: "20",
  code: "EG"
  },
  {
  name: "El Salvador",
  dialCode: "503",
  code: "SV"
  },
  {
  name: "Equatorial Guinea",
  dialCode: "240",
  code: "GQ"
  },
  {
  name: "Eritrea",
  dialCode: "291",
  code: "ER"
  },
  {
  name: "Estonia",
  dialCode: "372",
  code: "EE"
  },
  {
  name: "Ethiopia",
  dialCode: "251",
  code: "ET"
  },
  {
  name: "Falkland Islands (Malvinas)",
  dialCode: "500",
  code: "FK"
  },
  {
  name: "Faroe Islands",
  dialCode: "298",
  code: "FO"
  },
  {
  name: "Fiji",
  dialCode: "679",
  code: "FJ"
  },
  {
  name: "Finland",
  dialCode: "358",
  code: "FI"
  },
  {
  name: "France",
  dialCode: "33",
  code: "FR"
  },
  {
  name: "French Guiana",
  dialCode: "594",
  code: "GF"
  },
  {
  name: "French Polynesia",
  dialCode: "689",
  code: "PF"
  },
  {
  name: "Gabon",
  dialCode: "241",
  code: "GA"
  },
  {
  name: "Gambia",
  dialCode: "220",
  code: "GM"
  },
  {
  name: "Georgia",
  dialCode: "995",
  code: "GE"
  },
  {
  name: "Germany",
  dialCode: "49",
  code: "DE"
  },
  {
  name: "Ghana",
  dialCode: "233",
  code: "GH"
  },
  {
  name: "Gibraltar",
  dialCode: "350",
  code: "GI"
  },
  {
  name: "Greece",
  dialCode: "30",
  code: "GR"
  },
  {
  name: "Greenland",
  dialCode: "299",
  code: "GL"
  },
  {
  name: "Grenada",
  dialCode: "1473",
  code: "GD"
  },
  {
  name: "Guadeloupe",
  dialCode: "590",
  code: "GP"
  },
  {
  name: "Guam",
  dialCode: "1671",
  code: "GU"
  },
  {
  name: "Guatemala",
  dialCode: "502",
  code: "GT"
  },
  {
  name: "Guernsey",
  dialCode: "44",
  code: "GG"
  },
  {
  name: "Guinea",
  dialCode: "224",
  code: "GN"
  },
  {
  name: "Guinea-Bissau",
  dialCode: "245",
  code: "GW"
  },
  {
  name: "Guyana",
  dialCode: "595",
  code: "GY"
  },
  {
  name: "Haiti",
  dialCode: "509",
  code: "HT"
  },
  {
  name: "Holy See (Vatican City State)",
  dialCode: "379",
  code: "VA"
  },
  {
  name: "Honduras",
  dialCode: "504",
  code: "HN"
  },
  {
  name: "Hong Kong",
  dialCode: "852",
  code: "HK"
  },
  {
  name: "Hungary",
  dialCode: "36",
  code: "HU"
  },
  {
  name: "Iceland",
  dialCode: "354",
  code: "IS"
  },
  {
  name: "India",
  dialCode: "91",
  code: "IN"
  },
  {
  name: "Indonesia",
  dialCode: "62",
  code: "ID"
  },
  {
  name: "Iran, Islamic Republic of Persian Gulf",
  dialCode: "98",
  code: "IR"
  },
  {
  name: "Iraq",
  dialCode: "964",
  code: "IQ"
  },
  {
  name: "Ireland",
  dialCode: "353",
  code: "IE"
  },
  {
  name: "Isle of Man",
  dialCode: "44",
  code: "IM"
  },
  {
  name: "Israel",
  dialCode: "972",
  code: "IL"
  },
  {
  name: "Italy",
  dialCode: "39",
  code: "IT"
  },
  {
  name: "Jamaica",
  dialCode: "1876",
  code: "JM"
  },
  {
  name: "Japan",
  dialCode: "81",
  code: "JP"
  },
  {
  name: "Jersey",
  dialCode: "44",
  code: "JE"
  },
  {
  name: "Jordan",
  dialCode: "962",
  code: "JO"
  },
  {
  name: "Kazakhstan",
  dialCode: "77",
  code: "KZ"
  },
  {
  name: "Kenya",
  dialCode: "254",
  code: "KE"
  },
  {
  name: "Kiribati",
  dialCode: "686",
  code: "KI"
  },
  {
  name: "Korea, Democratic People's Republic of Korea",
  dialCode: "850",
  code: "KP"
  },
  {
  name: "Korea, Republic of South Korea",
  dialCode: "82",
  code: "KR"
  },
  {
  name: "Kuwait",
  dialCode: "965",
  code: "KW"
  },
  {
  name: "Kyrgyzstan",
  dialCode: "996",
  code: "KG"
  },
  {
  name: "Laos",
  dialCode: "856",
  code: "LA"
  },
  {
  name: "Latvia",
  dialCode: "371",
  code: "LV"
  },
  {
  name: "Lebanon",
  dialCode: "961",
  code: "LB"
  },
  {
  name: "Lesotho",
  dialCode: "266",
  code: "LS"
  },
  {
  name: "Liberia",
  dialCode: "231",
  code: "LR"
  },
  {
  name: "Libyan Arab Jamahiriya",
  dialCode: "218",
  code: "LY"
  },
  {
  name: "Liechtenstein",
  dialCode: "423",
  code: "LI"
  },
  {
  name: "Lithuania",
  dialCode: "370",
  code: "LT"
  },
  {
  name: "Luxembourg",
  dialCode: "352",
  code: "LU"
  },
  {
  name: "Macao",
  dialCode: "853",
  code: "MO"
  },
  {
  name: "Macedonia",
  dialCode: "389",
  code: "MK"
  },
  {
  name: "Madagascar",
  dialCode: "261",
  code: "MG"
  },
  {
  name: "Malawi",
  dialCode: "265",
  code: "MW"
  },
  {
  name: "Malaysia",
  dialCode: "60",
  code: "MY"
  },
  {
  name: "Maldives",
  dialCode: "960",
  code: "MV"
  },
  {
  name: "Mali",
  dialCode: "223",
  code: "ML"
  },
  {
  name: "Malta",
  dialCode: "356",
  code: "MT"
  },
  {
  name: "Marshall Islands",
  dialCode: "692",
  code: "MH"
  },
  {
  name: "Martinique",
  dialCode: "596",
  code: "MQ"
  },
  {
  name: "Mauritania",
  dialCode: "222",
  code: "MR"
  },
  {
  name: "Mauritius",
  dialCode: "230",
  code: "MU"
  },
  {
  name: "Mayotte",
  dialCode: "262",
  code: "YT"
  },
  {
  name: "Mexico",
  dialCode: "52",
  code: "MX"
  },
  {
  name: "Micronesia, Federated States of Micronesia",
  dialCode: "691",
  code: "FM"
  },
  {
  name: "Moldova",
  dialCode: "373",
  code: "MD"
  },
  {
  name: "Monaco",
  dialCode: "377",
  code: "MC"
  },
  {
  name: "Mongolia",
  dialCode: "976",
  code: "MN"
  },
  {
  name: "Montenegro",
  dialCode: "382",
  code: "ME"
  },
  {
  name: "Montserrat",
  dialCode: "1664",
  code: "MS"
  },
  {
  name: "Morocco",
  dialCode: "212",
  code: "MA"
  },
  {
  name: "Mozambique",
  dialCode: "258",
  code: "MZ"
  },
  {
  name: "Myanmar",
  dialCode: "95",
  code: "MM"
  },
  {
  name: "Namibia",
  dialCode: "264",
  code: "NA"
  },
  {
  name: "Nauru",
  dialCode: "674",
  code: "NR"
  },
  {
  name: "Nepal",
  dialCode: "977",
  code: "NP"
  },
  {
  name: "Netherlands",
  dialCode: "31",
  code: "NL"
  },
  {
  name: "Netherlands Antilles",
  dialCode: "599",
  code: "AN"
  },
  {
  name: "New Caledonia",
  dialCode: "687",
  code: "NC"
  },
  {
  name: "New Zealand",
  dialCode: "64",
  code: "NZ"
  },
  {
  name: "Nicaragua",
  dialCode: "505",
  code: "NI"
  },
  {
  name: "Niger",
  dialCode: "227",
  code: "NE"
  },
  {
  name: "Nigeria",
  dialCode: "234",
  code: "NG"
  },
  {
  name: "Niue",
  dialCode: "683",
  code: "NU"
  },
  {
  name: "Norfolk Island",
  dialCode: "672",
  code: "NF"
  },
  {
  name: "Northern Mariana Islands",
  dialCode: "1670",
  code: "MP"
  },
  {
  name: "Norway",
  dialCode: "47",
  code: "NO"
  },
  {
  name: "Oman",
  dialCode: "968",
  code: "OM"
  },
  {
  name: "Pakistan",
  dialCode: "92",
  code: "PK"
  },
  {
  name: "Palau",
  dialCode: "680",
  code: "PW"
  },
  {
  name: "Palestinian Territory, Occupied",
  dialCode: "970",
  code: "PS"
  },
  {
  name: "Panama",
  dialCode: "507",
  code: "PA"
  },
  {
  name: "Papua New Guinea",
  dialCode: "675",
  code: "PG"
  },
  {
  name: "Paraguay",
  dialCode: "595",
  code: "PY"
  },
  {
  name: "Peru",
  dialCode: "51",
  code: "PE"
  },
  {
  name: "Philippines",
  dialCode: "63",
  code: "PH"
  },
  {
  name: "Pitcairn",
  dialCode: "872",
  code: "PN"
  },
  {
  name: "Poland",
  dialCode: "48",
  code: "PL"
  },
  {
  name: "Portugal",
  dialCode: "351",
  code: "PT"
  },
  {
  name: "Puerto Rico",
  dialCode: "1939",
  code: "PR"
  },
  {
  name: "Qatar",
  dialCode: "974",
  code: "QA"
  },
  {
  name: "Romania",
  dialCode: "40",
  code: "RO"
  },
  {
  name: "Russia",
  dialCode: "7",
  code: "RU"
  },
  {
  name: "Rwanda",
  dialCode: "250",
  code: "RW"
  },
  {
  name: "Reunion",
  dialCode: "262",
  code: "RE"
  },
  {
  name: "Saint Barthelemy",
  dialCode: "590",
  code: "BL"
  },
  {
  name: "Saint Helena, Ascension and Tristan Da Cunha",
  dialCode: "290",
  code: "SH"
  },
  {
  name: "Saint Kitts and Nevis",
  dialCode: "1869",
  code: "KN"
  },
  {
  name: "Saint Lucia",
  dialCode: "1758",
  code: "LC"
  },
  {
  name: "Saint Martin",
  dialCode: "590",
  code: "MF"
  },
  {
  name: "Saint Pierre and Miquelon",
  dialCode: "508",
  code: "PM"
  },
  {
  name: "Saint Vincent and the Grenadines",
  dialCode: "1784",
  code: "VC"
  },
  {
  name: "Samoa",
  dialCode: "685",
  code: "WS"
  },
  {
  name: "San Marino",
  dialCode: "378",
  code: "SM"
  },
  {
  name: "Sao Tome and Principe",
  dialCode: "239",
  code: "ST"
  },
  {
  name: "Saudi Arabia",
  dialCode: "966",
  code: "SA"
  },
  {
  name: "Senegal",
  dialCode: "221",
  code: "SN"
  },
  {
  name: "Serbia",
  dialCode: "381",
  code: "RS"
  },
  {
  name: "Seychelles",
  dialCode: "248",
  code: "SC"
  },
  {
  name: "Sierra Leone",
  dialCode: "232",
  code: "SL"
  },
  {
  name: "Singapore",
  dialCode: "65",
  code: "SG"
  },
  {
  name: "Slovakia",
  dialCode: "421",
  code: "SK"
  },
  {
  name: "Slovenia",
  dialCode: "386",
  code: "SI"
  },
  {
  name: "Solomon Islands",
  dialCode: "677",
  code: "SB"
  },
  {
  name: "Somalia",
  dialCode: "252",
  code: "SO"
  },
  {
  name: "South Africa",
  dialCode: "27",
  code: "ZA"
  },
  {
  name: "South Georgia and the South Sandwich Islands",
  dialCode: "500",
  code: "GS"
  },
  {
  name: "Spain",
  dialCode: "34",
  code: "ES"
  },
  {
  name: "Sri Lanka",
  dialCode: "94",
  code: "LK"
  },
  {
  name: "Sudan",
  dialCode: "249",
  code: "SD"
  },
  {
  name: "Suriname",
  dialCode: "597",
  code: "SR"
  },
  {
  name: "Svalbard and Jan Mayen",
  dialCode: "47",
  code: "SJ"
  },
  {
  name: "Swaziland",
  dialCode: "268",
  code: "SZ"
  },
  {
  name: "Sweden",
  dialCode: "46",
  code: "SE"
  },
  {
  name: "Switzerland",
  dialCode: "41",
  code: "CH"
  },
  {
  name: "Syrian Arab Republic",
  dialCode: "963",
  code: "SY"
  },
  {
  name: "Taiwan",
  dialCode: "886",
  code: "TW"
  },
  {
  name: "Tajikistan",
  dialCode: "992",
  code: "TJ"
  },
  {
  name: "Tanzania, United Republic of Tanzania",
  dialCode: "255",
  code: "TZ"
  },
  {
  name: "Thailand",
  dialCode: "66",
  code: "TH"
  },
  {
  name: "Timor-Leste",
  dialCode: "670",
  code: "TL"
  },
  {
  name: "Togo",
  dialCode: "228",
  code: "TG"
  },
  {
  name: "Tokelau",
  dialCode: "690",
  code: "TK"
  },
  {
  name: "Tonga",
  dialCode: "676",
  code: "TO"
  },
  {
  name: "Trinidad and Tobago",
  dialCode: "1868",
  code: "TT"
  },
  {
  name: "Tunisia",
  dialCode: "216",
  code: "TN"
  },
  {
  name: "Turkey",
  dialCode: "90",
  code: "TR"
  },
  {
  name: "Turkmenistan",
  dialCode: "993",
  code: "TM"
  },
  {
  name: "Turks and Caicos Islands",
  dialCode: "1649",
  code: "TC"
  },
  {
  name: "Tuvalu",
  dialCode: "688",
  code: "TV"
  },
  {
  name: "Uganda",
  dialCode: "256",
  code: "UG"
  },
  {
  name: "Ukraine",
  dialCode: "380",
  code: "UA"
  },
  {
  name: "United Arab Emirates",
  dialCode: "971",
  code: "AE"
  },
  {
  name: "United Kingdom",
  dialCode: "44",
  code: "GB"
  },
  {
  name: "United States",
  dialCode: "1",
  code: "US"
  },
  {
  name: "Uruguay",
  dialCode: "598",
  code: "UY"
  },
  {
  name: "Uzbekistan",
  dialCode: "998",
  code: "UZ"
  },
  {
  name: "Vanuatu",
  dialCode: "678",
  code: "VU"
  },
  {
  name: "Venezuela, Bolivarian Republic of Venezuela",
  dialCode: "58",
  code: "VE"
  },
  {
  name: "Vietnam",
  dialCode: "84",
  code: "VN"
  },
  {
  name: "Virgin Islands, British",
  dialCode: "1284",
  code: "VG"
  },
  {
  name: "Virgin Islands, U.S.",
  dialCode: "1340",
  code: "VI"
  },
  {
  name: "Wallis and Futuna",
  dialCode: "681",
  code: "WF"
  },
  {
  name: "Yemen",
  dialCode: "967",
  code: "YE"
  },
  {
  name: "Zambia",
  dialCode: "260",
  code: "ZM"
  },
  {
  name: "Zimbabwe",
  dialCode: "263",
  code: "ZW"
  }
]



export const weekDays = ['sun','mon','tue','wed','thu','fri','sat']
export const genericDomains = [ 'zoho', 'gmail.com', 'yahoo.com', 'yahoo.co.in', 'yahoo.in', 'rediffmail.com','outlook.com', 'hotmail.com', 'hotmail.in','ymail.com']
export const broadcastCompanyIds = ['6501a91840420251ca640bfa','6368de9abbb0fd6360ff64a5','6345588a84240049883b50cb','61dbebf96dffb6300e103f23','64896da604d4d71e373598ec','681084daaa0b6d2346475f2b','67483b9c1fcd6d495962a2f8','64b77c8ec14e11111de073b0']

export const loginPageContent : any = [{
  quote : "The best way to predict your future is to create it",
  imageLink : "https://qdesq.imagekit.io/image/upload/v1641815575/aen0z3p69190gpntwddo.png"
},{
  quote : "The most effective way to do it, is to do it",
  imageLink : "https://qdesq.imagekit.io/img/image/upload/v1641815330/athkufjjzph8nplwk9qm.png"
},{
  quote : "We will either find a way or make one",
  imageLink : "https://qdesq.imagekit.io/image/upload/v1641815761/on07qis8x2et1bvdugxk.png"
},{
  quote : "you’re not going fast enough",
  imageLink : "https://qdesq.imagekit.io/image/upload/v1641815876/rpt8fc9fbtcptgxonimp.png"
},
{
  quote : "Don’t count the days, make the days count",
  imageLink : "https://qdesq.imagekit.io/image/upload/v1641815936/pjm4wx3bwbzkbtghg2tv.png"
},
{
  quote : "If everything seems under control, you’re not going fast enough",
  imageLink : "https://qdesq.imagekit.io/image/upload/v1641816051/epg6lakgh6tz68mswe0a.png"
},
{
  quote : "you’re not going fast enough",
  imageLink : "https://qdesq.imagekit.io/img/image/upload/v1650619583/epl2f2aoph53reoigquq.jpg"
},
]

export const loginWithMicrosoftCompanies = ['65169c12eb2c20f30490053c','64c8ad2fa9268d69edfc92d4','61dbebf96dffb6300e103f23','61de71b92a066c419129e187', '6513ffbbd8d6a7101b53a51c']
export const oktaLoginUrls = [
  // {
  //   companyId:'6549d073d014c117d329166b', // test jll
  //   loginUrl:'https://applogin-uat.jll.com/app/jllpoc_qudifytestuatsamlad_1/exk1va2l1tatCu69j0h8/sso/saml',
  //   domains:[]
  // },
  {
    companyId:'64896da604d4d71e373598ec',    // live jll
    loginUrl:'https://applogin.jll.com/app/jll_qudifysamlad_1/exk1u3wmqik6K6cp90h8/sso/saml',
    domains:['jll.com']
  },
  {
    companyId:'61de71b92a066c419129e187',
    loginUrl:'https://dev-50888533.okta.com/app/dev-50888533_newtestapp_1/exkcz0pgekirSxxfy5d7/sso/saml',
    domains:['dfdsf.dsf','qdesq.com']
  },
  {
    companyId:'674803377e37d23bc6c1bc27',
    loginUrl:'https://dev-22575720.okta.com/app/dev-22575720_samlapp_1/exknjncqeb3zA47QM5d7/sso/saml',
    domains:['king5151.com']
  },
  {
    companyId:'67483b9c1fcd6d495962a2f8',
    loginUrl:'https://dev-22575720.okta.com/app/dev-22575720_samlapp_1/exknjncqeb3zA47QM5d7/sso/saml',
    domains:['demo5151.com']
  },
  {
    companyId:'679c57fdbe667c19858336e6',
    loginUrl:'https://tower.okta.com/app/tower_qudifyvms_1/exkpcyeumuMv6UGEp697/sso/saml',
    domains:['tower-research.com']
  },
  {
    companyId:'67c582597790cc173560dda3',
    loginUrl:'https://tower.okta.com/app/tower_qudifyvms_1/exkpcyeumuMv6UGEp697/sso/saml',
    domains:['tower-research.com']
  }
]

export const PlakshSpecificPassRelatedChangesCompanyIds = ['64c8ad2fa9268d69edfc92d4','6568703a7410e77deb4ff13f']
// {
//   "name": "Asia/Kolkata",
//   "alternativeName": "India Time",
//   "group": [
//     "Asia/Kolkata",
//     "Asia/Calcutta"
//   ],
//   "continentCode": "AS",
//   "continentName": "Asia",
//   "countryName": "India",
//   "countryCode": "IN",
//   "mainCities": [
//     "Mumbai",
//     "Delhi",
//     "Bengaluru",
//     "Hyderābād"
//   ],
//   "rawOffsetInMinutes": 330,
//   "abbreviation": "IST",
//   "rawFormat": "+05:30 India Time - Mumbai, Delhi, Bengaluru, Hyderābād"
// },

export const ignoreLoginNavigationUrls = ['visitor-checkin?','visitor-checkout?','visitor-prebooking','security-team-pass-verification','employee-access-view','feedback-and-complaints']
export const employeesCanPreInviteVisitorsFromLoginPage = ['641aaeb73eb544647eaf68b6','656f3f61b0e91a0388b20720','64f56dfd47116e42e4282847']
export const contactNumberOptionalInAddEmplpoyee = ['660baa91d87d3e03bd8ff33c', '66056300b5c25942f3819884', '659d264bf3baa403686d05e7','69390f4216398c2b80bc6cb2','6940018f02718552b0fd6433','6a3135115ff38e10041c16c0','6912d96935084674ca0e45b8']
export const conditionalWalkinPassInputFiedInVisitorDetails = [
  {
    companyId:'660baa91d87d3e03bd8ff33c',
    officeId:'660bab3ad87d3e03bd8ff360',
    fieldReferenceName:'assetID',
    condition: {
      referenceName:"carryingAnyDigitalAsset",
      value:'yes'
    }
  },
  {
    companyId:'64896da604d4d71e373598ec',
    officeId:'6489734604d4d71e3735add7',
    fieldReferenceName:'acc.Details',
    condition: {
      referenceName:"accessories",
      value:'yes'
    }
  },
  {
    companyId:'64896da604d4d71e373598ec',
    officeId:'6582ccc0c1ed403381eb2bd4',
    fieldReferenceName:'accessoryDescription',
    condition: {
      referenceName:"carryingAnyAccessory",
      value:'yes'
    }
  },
  {
    companyId:'64896da604d4d71e373598ec',         //JLL aurangabad 
    officeId:'67dbbfbaab985b05361f6207',
    fieldReferenceName:'assetID',
    condition: {
      referenceName:"carryingAnyDigitalAsset",
      value:'yes'
    }
  },
  {
    companyId:'6549d073d014c117d329166b',         //test JLL aurangabad 
    officeId:'67ecd328ac135344aff908d7',
    fieldReferenceName:'assetID',
    condition: {
      referenceName:"carryingAnyDigitalAsset",
      value:'yes'
    }
  },

  {
    companyId:'68060a289a67bc7cdd97bc36',         //test grasim  stable fibre
    officeId:'68060e179a67bc7cdd97c1c2',
    fieldReferenceName:'enterAccessoryDetails',
    condition: {
      referenceName:"accessoriesCarried",
      value:'/'
    }
  },
  {
    companyId:'667bd55c8ab2c2761dcf940c',         //grasim stable fiber live  
    officeId:'6780d8b2367279399c6b7131',
    fieldReferenceName:'enterAccessoryDetails',
    condition: {
      referenceName:"accessoriesCarried",
      value:'/'
    }
  },
  {
    companyId:'67483b9c1fcd6d495962a2f8',         //grasim  live  test account
    officeId:'67483c7c1fcd6d495962bb1b',
    fieldReferenceName:'enterAccessoryDetails',
    condition: {
      referenceName:"accessoriesCarried",
      value:'/'
    }
  },

  {
    companyId:'689aca7f3ee3397ebc351f76',         //brigade => corporate office test  
    officeId:'689acc693ee3397ebc35203f',
    fieldReferenceName:'name/SOfAdditionalGuest/S',
    condition: {
      referenceName:"no.OfAdditionalGuests",
      value:['1','2','3','4','5']
    }
  },
  {
    companyId:'66f63acef2fd080e5854a69d',         //brigade   live   account
    officeId:'66f63b56f2fd080e5854b4ba',
    fieldReferenceName:'name/SOfAdditionalGuest/S',
    condition: {
      referenceName:"no.OfAdditionalGuest",
      value:['1','2','3','4','5','6','7','8','9','10']
    }
  }



  
]
export const captureCompaignParameters = [
  {
    urlKey:'utm_medium',
    leadkey:'utmMedium'
  },
  {
    urlKey:'utm_campaign',
    leadkey:'utmCampaign'
  },
  {
    urlKey:'utm_term',
    leadkey:'utmTerm'
  },
  {
    urlKey:'utm_source',
    leadkey:'utmSource'
  },
  {
    urlKey:'fbclid',
    leadkey:'fbclid'
  },
  {
    urlKey:'li_fat_id',
    leadkey:'linkedInFatId'
  }

]
export const companyIdsToEnableVIPPassForEmployeesInPreInvite = ['660baa91d87d3e03bd8ff33c','65a12920ab973878a90acc77','675966c8be7cfac02c75eb21','6530bc36e365a86458d50dbc']

export const RegencyNirmanClientSpecificChanges = ['661e5d568bad7c6bf16eb492','65685c5ce3a5046fb08053f3']

export const CompanyIdsWithDepartmentOptionalInPreInviteCompanyPass = ['660baa91d87d3e03bd8ff33c','64896da604d4d71e373598ec','6513ffbbd8d6a7101b53a51c','69bbd7dd843c29882d92d4d1']

export const CompanyIdsToDisplayLogoWithPoweredBy = ['6645db3e33b5d437db135dc8', '66265861c6c6c99b709f952d']

export const CompanyIdsForLloydsClientSpecificChanges = ['658e7902393ffd03bd9f2237','64f056d4bbac654ac9c612d1']
export const CompanyIdsToDisplayVisitorContactDetailsInPass = ['658e7902393ffd03bd9f2237','6486b904c5faff0ff5e94e90'] 
export const CompanyIdsForOphiliaClientSpecificChanges = ['645e32c896c6ff59c0b70895', '64b62f817989b17df998fee6','651e96d90fd30c8886c0b4b3', '664d950fc9ff85323cc49898', '656f3f61b0e91a0388b20720']
export const CompanyIdsToHideQRCodeInVMSCheckInApplication = ['664d950fc9ff85323cc49898', '651e96d90fd30c8886c0b4b3']
export const CompanyIdToHideDepartmentInWalkinVisitorFlow = ['650979601090d3c42c45d3be','6658452ed0da2e175e794823','649d5a19ea6b96b8889b488c','66b1f54e1d87742494881ba7','65e1d9a42e0df261912dd860']
export const CompanyIdToHidePOCDetailsInWalkinVisitorFlowAndPass = ['650979601090d3c42c45d3be','6658452ed0da2e175e794823','6982e80856d2870478cbe149','68db83d11dc16123818b8070','67483b9c1fcd6d495962a2f8']
export const DaysLimitOnCustomMeetingRoomBookings = [
  {
    companyId:'657a8b594d09481c9552f75c',
    days:10        
  },
  {
    companyId:'65b0f7d2ccfa9cad2298f095',
    days:10
  },
  {
    companyId:'6532a9b78a3d1522ac78b231',
    days:10
  },
  {
    companyId:'6745aa404a3b2f424b9b186b',
    days:5
  },
  {
    companyId:'64cc9651b039c564d80385d0',
    days:5
  },
  {
    companyId:'67483b9c1fcd6d495962a2f8',
    days:5
  },
  {
    companyId:'67b81c3cb574990d5588e788',
    days:7
  },
  {
    companyId:'67c57d4c7790cc173560dc69',      // Tower Research TEST
    days:7
  },
  
]
export const CleintWiseCustomMeetingRoomBookingOptions = [
  {
    companyId:'657a8b594d09481c9552f75c',
    options: [
      {
        name: 'Do not repeat',
        value:'do not repeat'
      },
      {
        name: 'Daily',
        value:'daily'
      },
      {
        name: 'Weekly on ',
        value:'weekly'
      },
      {
        name: 'Custom',
        value:'custom'
      }
    ]        
  },
  {
    companyId:'65b0f7d2ccfa9cad2298f095',
    options: [
      {
        name: 'Do not repeat',
        value:'do not repeat'
      },
      {
        name: 'Daily',
        value:'daily'
      },
      {
        name: 'Weekly on ',
        value:'weekly'
      },
      {
        name: 'Custom',
        value:'custom'
      }
    ]
  },
  {
    companyId:'6532a9b78a3d1522ac78b231',
    options: [
      {
        name: 'Do not repeat',
        value:'do not repeat'
      },
      {
        name: 'Daily',
        value:'daily'
      },
      {
        name: 'Weekly on ',
        value:'weekly'
      },
      {
        name: 'Custom',
        value:'custom'
      }
    ]
  }
]

export const CompanyIdsToDisableRecurringMeetingRoomBookings = ['652fc710e349446e23d08933', '628b62014562751b8cc225fd', '64cc9651b039c564d80385d0','6745aa404a3b2f424b9b186b', '67483b9c1fcd6d495962a2f8','67b47ac38ca46a3de3cf4057' ]
export const CompanyIdsForLoginWithEmailOnlyInPreInviteFlow = ['64e48fcd04a6c9484bb7cdfa', '665af5281270d57b1a0f3bfd'];

export const ExtendWalkinPassValidityTimeFromCurrentDate = [
  {
    companyId:'66629bd25583aa6ff695fc3b',   // cloud9 events
    daysExtended: 5
  },
  {
    companyId:'6500165acc520f66f5089f78',   // test
    daysExtended: 5
  },
  {
    companyId:'6532d0522a021b4acde14810',   // live demo
    daysExtended: 5
  },
  {
    companyId:'69bbab3d0395ae371ee60b19',   // test
    // daysExtended: 5
  },
  {
    companyId:'68db83d11dc16123818b8070',   // live plasser India
    // daysExtended: 5
  }
]

export const InternetOnOffModel = ['display-meeting-room-bookings', 'visitor-checkin?refId', 'visitor-checkout?refId','/admin-dash/']

export const RedirectToDynamicFeedbacksAndShowOnlyFeedback = ['64b9192c95c7ab54feacaa46','6703d5e3026872349c8a8d96']

export const bookingApprovalCapCustomizationsWithBookingApprovalAddonAdded = [      // MR approval will not be sent if mentioned Booking duration is less thaan mentioned slots

  {
    companyId:'6745aa404a3b2f424b9b186b',   // test Mama Earth 2
    numberOfSlots:8
  },
  {
    companyId:'64cc9651b039c564d80385d0', // live mama earth
    numberOfSlots:8
  },
  {
    companyId:'67483b9c1fcd6d495962a2f8', // live demo  Test King Pvt.
    numberOfSlots:4
  }


]
export const constSessionCredentials = {
  secretv:'d43cb98ef0c1a25e32f461573f68a9a1',
  secretKey:'vOVF6sdmpNWjRRIqCc7rdxs01lwHzfr3'

}

export const calenderShouldBeEnabledOnlyForSpecifiedDates = [
  {
    companyId:'6745aa404a3b2f424b9b186b',
   dates: ['18-Dec-2025','19-Dec-2025','20-Dec-2025']
  },
  {
    companyId:'675bb43f50595565970d9a89',
    dates: ['18-Dec-2025','19-Dec-2025','20-Dec-2025']
  },
  {
    companyId:'6310873ee61a2d4356bc3316',
    dates: ['18-Dec-2025','19-Dec-2025','20-Dec-2025']
  }
]

export const defaultPassValidityInWalkinPasses = [
  {
    companyId: '6745aa404a3b2f424b9b186b',  // Mama Earth 2 === on test 
     startTime:'2026-06-21T18:30:00.000Z',
    endTime: '2026-06-22T18:29:59.999Z',
    isMultipleCheckinAllowed: true
  },
  {
    companyId: '675bb43f50595565970d9a89',   // bio energy == live
    startTime:'2025-12-17T18:30:00.000Z',
    endTime: '2025-12-20T18:29:59.999Z',
    isMultipleCheckinAllowed: true
  },
  {
    companyId: '6310873ee61a2d4356bc3316',
     startTime:'2025-12-17T18:30:00.000Z',
    endTime: '2025-12-20T18:29:59.999Z',
    isMultipleCheckinAllowed: true
  },
  {
    companyId: '6927ee1d53bae058cc8089ca',
     startTime:'2026-01-04T18:30:00.000Z',
    endTime: '2026-01-06T18:29:59.999Z',
    isMultipleCheckinAllowed: true
  },
  {
    companyId: '6a2268c19c51f42b60ff7bf9',
    startTime:'2026-06-23T18:30:00.000Z',
    endTime: '2026-06-24T18:29:59.999Z',
    isMultipleCheckinAllowed: true
  },
  
  
]



export const setDefaultHostForWalkinVisitorPassesMeetingAppointmentAndService = [
  {
    companyId:'6745aa404a3b2f424b9b186b',     // test company
    name:'wf wf wef we',
    hostEmail: 'wefef@mama.com',
    contactNumber:'9898989891'
  },
  {
    companyId:'675bb43f50595565970d9a89',       // bio energy india
    name:'Bio Energy India',
    hostEmail: 'bioenergyindia18@gmail.com',
    contactNumber:'7011807613'
  },
  {
    companyId:'6310873ee61a2d4356bc3316',     // test company
    name:'wf wf wef we',
    hostEmail: 'wefef@mama.com',
    contactNumber:'8080473037'
  }
]

export const OfficeIdsToSkipSelfiePage = ['67987fc38e291aa4cec5a25d', '6790cadbba79336f1fd8ee52']

export const OfficeIdsRemoveVehicleNumberInputForPreInvites = ['67987fc38e291aa4cec5a25d', '6790cadbba79336f1fd8ee52', '6971ed52d9a60bd9d1df2af3', '693bbaec86949078be9a3d04', "69b91fdb0395ae371ee43beb", "69b91fdb0395ae371ee43c12", "69b91fdb0395ae371ee43c4f", "69b91fdc0395ae371ee43cdb", "69b91fdd0395ae371ee43dd1", "69b91fdd0395ae371ee43eec", "69b91fde0395ae371ee440a6", "69b2776eac2e016e25b8552a", "69b2776eac2e016e25b85579", "69b2776fac2e016e25b855bf", "69b2776fac2e016e25b85626", "69b2776fac2e016e25b856ca", "69b27770ac2e016e25b85784", "69b27770ac2e016e25b858fa",'69bbd82f843c29882d92d4fa','69427bde6141632141a5a16c'] // 693bbaec86949078be9a3d04 = jll 20 water salt office

export const OfficeIdsForAddingVisitorDesignationInMAPreInvitePass = [
  // {
  //   officeId:'67987fc38e291aa4cec5a25d',   //test jll
  //   label:'Company - Job Description'
  // },
  // {
  //   officeId:'6790cadbba79336f1fd8ee52',   //live jll
  //   label:'Company - Job Description'
  // }
]

export const OfficeIdsForJLLPurposeOfVisitNameChanges = ['67987fc38e291aa4cec5a25d', '6790cadbba79336f1fd8ee52', '6971ed52d9a60bd9d1df2af3', '693bbaec86949078be9a3d04', "69b91fdb0395ae371ee43beb", "69b91fdb0395ae371ee43c12", "69b91fdb0395ae371ee43c4f", "69b91fdc0395ae371ee43cdb", "69b91fdd0395ae371ee43dd1", "69b91fdd0395ae371ee43eec", "69b91fde0395ae371ee440a6", "69b2776eac2e016e25b8552a", "69b2776eac2e016e25b85579", "69b2776fac2e016e25b855bf", "69b2776fac2e016e25b85626", "69b2776fac2e016e25b856ca", "69b27770ac2e016e25b85784", "69b27770ac2e016e25b858fa",'69bbd82f843c29882d92d4fa']  //693bbaec86949078be9a3d04 = jll 20 water salt office

export const companyIdsForFiveTenantCompanies = ['6735e77d41a2fc6b29e4b662','674803377e37d23bc6c1bc27','6839666d669529699867ad22','691f2383401ba1628f3014ea']

export const IdsForDeclarationCheckboxOptionalInWalkinScreenFive = ['67987fc38e291aa4cec5a25d', '6790cadbba79336f1fd8ee52','6971ed52d9a60bd9d1df2af3', '693bbaec86949078be9a3d04', "69b91fdb0395ae371ee43beb", "69b91fdb0395ae371ee43c12", "69b91fdb0395ae371ee43c4f", "69b91fdc0395ae371ee43cdb", "69b91fdd0395ae371ee43dd1", "69b91fdd0395ae371ee43eec", "69b91fde0395ae371ee440a6", "69b2776eac2e016e25b8552a", "69b2776eac2e016e25b85579", "69b2776fac2e016e25b855bf", "69b2776fac2e016e25b85626", "69b2776fac2e016e25b856ca", "69b27770ac2e016e25b85784", "69b27770ac2e016e25b858fa",'69bbd82f843c29882d92d4fa']

// export  
// Remove Visitor's Vehicle Number field

export const companyIdsToEnableSetEndTimeForPreInvitePassesFromAdminDash = [] //['674803377e37d23bc6c1bc27','66f63acef2fd080e5854a69d','67483b9c1fcd6d495962a2f8']

export const OfficeIdsForGrasimPurposeOfVisitBehaviourChanges = ['6780d8b2367279399c6b7131','68060e179a67bc7cdd97c1c2','67483c7c1fcd6d495962bb1b']

export const companyIdsToShowRefreshEasyWdmsVisits = ['66f502dcf2fd080e5848a046', '6735e77d41a2fc6b29e4b662', '66f502dcf2fd080e5848a046', '66a38410027d1503c00af6f3','66a3643b027d1503c008d27b']

export const CompanyIdsToDisplayDepartmentDropdownInPOCSelection = ['6645db3e33b5d437db135dc8','675fc7a2de9e4163e0599c9a','6641a2d633b5d437dbf33f5f','674803377e37d23bc6c1bc27','64c791d6c7b49931a4bc0f6c','6875f1bf5a996b16a5f4890c','69c0e6d5fd3b6832f0792d44']

export const CompanyIdsToHideValidityInPass = ['64a28ce0cfb700061a39ab80']
export const products = [
    {
      name : 'Meeting room and desk booking',
      productType : 'meeting-room',
      selected : false,
      code:1
    },
    {
      name : 'Visitor Check-In Management',
      productType : 'checkin-management',
      selected : false,
      code : 2
    },
    {
      name : 'Feedback & Complaints',
      productType : 'checkin-management',
      selected : false,
      code :3
    },
    {
      name : 'Feedback & Complaints',
      productType : 'checkin-management',
      selected : false,
      code :4
    },
]

export const CompanyIdsToEnableScreen5ForCompanyPasses = ['64f19c416f3a6f1e49b2246b','674031fdb4ae6a053f7cebf9','6735c53c41a2fc6b29e17f8f','68b942fe43bce7a14e91c1cc','67a328078b290b0e75f8d552','68db83d11dc16123818b8070','6496d1e0f2a6ff1d527ab5ea','64a25ed7cfb700061a38ed04','64a26162cfb700061a38fee5']

export const companyIdsToEnableSMSInBroadcastFeature = ['67e14dcf54c0024355460f4c','67483b9c1fcd6d495962a2f8','681084daaa0b6d2346475f2b']

export const templatesForSMSBroadcast = [
  {
    companyId:'67e14dcf54c0024355460f4c',
    templates : [
      {
        name :'Flash Floods – WFH',
        id:'684fb7c7d6fc054aa31ec412',
        content:`⚠️ Flash floods: WFH on {Date}. On-site staff, go to Designated Safe Area. Stay safe. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Palkhi Event – WFH',
        id:'684fb825d6fc0547197483b3',
        content: `⚠️ Palkhi traffic: WFH on {Date}. Avoid travel. On-site staff, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Emergency WFH',
        id:'684fb8a8d6fc056ee4054e33',
        content: `⚠️ Emergency: WFH on {Date}. Do not report. On-site, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Health & Safety – WFH',
        id:'684fb86ad6fc0567737976f2',
        content: `⚠️ Health alert: WFH on {Date}. Stay home. On-site staff, move to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Urgent Advisory – Plant Closed',
        id:'684fba46d6fc0563bb315cc2',
        content: `⚠️ Urgent: Plant closed {Date}. WFH. On-site staff, go to Designated Safe Area. Updates soon. – CMT<br><br>
Thanks Qudify`
      }

    ]
  },
  {
    companyId:'681084daaa0b6d2346475f2b',
    templates : [
      {
        name :'Flash Floods – WFH',
        id:'684fb7c7d6fc054aa31ec412',
        content:`⚠️ Flash floods: WFH on {Date}. On-site staff, go to Designated Safe Area. Stay safe. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Palkhi Event – WFH',
        id:'684fb825d6fc0547197483b3',
        content: `⚠️ Palkhi traffic: WFH on {Date}. Avoid travel. On-site staff, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Emergency WFH',
        id:'684fb8a8d6fc056ee4054e33',
        content: `⚠️ Emergency: WFH on {Date}. Do not report. On-site, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Health & Safety – WFH',
        id:'684fb86ad6fc0567737976f2',
        content: `⚠️ Health alert: WFH on {Date}. Stay home. On-site staff, move to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Urgent Advisory – Plant Closed',
        id:'684fba46d6fc0563bb315cc2',
        content: `⚠️ Urgent: Plant closed {Date}. WFH. On-site staff, go to Designated Safe Area. Updates soon. – CMT<br><br>
Thanks Qudify`
      }

    ]
  },
  {
    companyId:'67483b9c1fcd6d495962a2f8',  // live test company
    templates : [
      {
        name :'Flash Floods – WFH',
        id:'684fb7c7d6fc054aa31ec412',
        content:`⚠️ Flash floods: WFH on {Date}. On-site staff, go to Designated Safe Area. Stay safe. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Palkhi Event – WFH',
        id:'684fb825d6fc0547197483b3',
        content: `⚠️ Palkhi traffic: WFH on {Date}. Avoid travel. On-site staff, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Emergency WFH',
        id:'684fb8a8d6fc056ee4054e33',
        content: `⚠️ Emergency: WFH on {Date}. Do not report. On-site, go to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Health & Safety – WFH',
        id:'684fb86ad6fc0567737976f2',
        content: `⚠️ Health alert: WFH on {Date}. Stay home. On-site staff, move to Designated Safe Area. – CMT<br><br>
Thanks Qudify`
      },
      {
        name :'Urgent Advisory – Plant Closed',
        id:'684fba46d6fc0563bb315cc2',
        content: `⚠️ Urgent: Plant closed {Date}. WFH. On-site staff, go to Designated Safe Area. Updates soon. – CMT<br><br>
Thanks Qudify`
      }

    ]
  }

]

export const OfficeIdsForGrasimBirlaCellulosic = ['68060e179a67bc7cdd97c1df','6780d8b2367279399c6b7154'] // test grasim - birla celulose, live
export const Cookie_Setting_Key = 'cookie_setting'

export const AnalyticsCookieList = ['_ga', '_ga_7PEJ0REHBG', '_ga_WQGX7PLP73', '_gat_UA-228516025-1', '_gid', 'ar_debug', '__hstc', 'APISID', 'AnalyticsSyncHistory', 'HSID', 'SAPISID', 'SID']

export const MarketingCookieList = ['_gcl_au', '_uetvid', 'bcookie', 'hubspotutk', 'intercom-id-lpvu1c5n', 'li_sugr', 'UserMatchHistory', '_fbp', 'AEC', 'AMCV_14215E3D5995C57C0A495C55', 'IDE', 'NID', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_source', 'fbclid', 'li_fat_id']

export const UnclassifiedCookieList = ['_hjSessionUser_494392', 'aam_uuid', 'intercom-device-id-lpvu1c5n', 'lang', 'UULE', '__stripe_mid'];

export const CompanyWiseHostSearchAndSelectionSetting = [
  {
    companyId:'674803377e37d23bc6c1bc27',
    minSearchTextLength:0
  },
  {
    companyId:'67af2b235118c11c97d41d02',
    minSearchTextLength:0
  },
  {
    companyId:'675fc7a2de9e4163e0599c9a',
    minSearchTextLength:0
  }
]

export const  CompanyIdsToDisableRecurringMeetingRoomBookingsForNoneAdmins = ['6793353bba79336f1f143fca','64be31f404f15912b78d201f']

export const displayCookieConsentPopupPages = ['/','/meeting-room-and-desk-booking','/visitor-management','/feedback-and-complaint-box']



export const CompanyIdsToHidePOCDetailsInPreInvitePasses = ['68b942fe43bce7a14e91c1cc','64a28ce0cfb700061a39ab80']

export const customOfficeWiseWalkinPassCategories = [
  {
    companyId:'6583ed8fc1ed403381ef4a42',
    officeId:['68e503176ed80a4169b253da'],
    categoriesEncluded: [
      {
        _id:'68f0f1394cacad114c7988e4',
        inputIds:['65854ae5d14e312ee315b505','65854ae5d14e312ee315b506','65f18e5d204dfe7ca0441dcb','68f123fe4cacad114c7d8283','68f123fe4cacad114c7d8284','68f123fe4cacad114c7d8285','68f123fe4cacad114c7d8286'] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'68f0f1394cacad114c7988ea',
        inputIds:['65854ae5d14e312ee315b505','65854ae5d14e312ee315b506','65f18e5d204dfe7ca0441dcb','68f123fe4cacad114c7d8284','68f123fe4cacad114c7d8285','68f123fe4cacad114c7d8286']
      }
    ],
    categoriesExcluded:[

    ]
  },
  {
    companyId:['68e8a1aa3c2482bd6ab1ec60'],
    officeId:['68e8a2f93c2482bd6ab1ecd5'],
    categoriesEncluded: [
      {
        _id:'68e8a5613c2482bd6ab1ee2a',
        inputIds:['65854ae5d14e312ee315b505','65854ae5d14e312ee315b506','65f18e5d204dfe7ca0441dcb','68f123fe4cacad114c7d8283','68f123fe4cacad114c7d8284','68f123fe4cacad114c7d8285','68f123fe4cacad114c7d8286'] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'68e8a5613c2482bd6ab1ee34',
        inputIds:['65854ae5d14e312ee315b505','65854ae5d14e312ee315b506','65f18e5d204dfe7ca0441dcb','68f123fe4cacad114c7d8284','68f123fe4cacad114c7d8285','68f123fe4cacad114c7d8286']
      }
    ],
    categoriesExcluded:[

    ]
  },

  {
    companyId:'6902140b2b9692931bfad32a',   //alten india test
    officeId:['690216d52b9692931bfad61b','690216d52b9692931bfad66f','690216d62b9692931bfad6a7','690216d62b9692931bfad6c3','690216d72b9692931bfad6fe'],
    categoriesEncluded: [
      {
        _id:'6909b2702b452a60309addbf',
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
     
    ],
    categoriesExcluded:[

    ]
  },

  {
    companyId:'686f940e9504d540aab9be84',   //alten india live
    officeId:['686f94cc9504d540aab9f39e','68ba87519ff41a52166f5b4f','68ba87519ff41a52166f5b85','68ba87519ff41a52166f5ba7','68c3c74063208b05e34e602f'],
    categoriesEncluded: [
      {
        _id:'6870d5d25902aa205cb9cd33',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      
    ],
    categoriesExcluded:[

    ]
  },
   {
    companyId:'667bd55c8ab2c2761dcf940c',   //Grasim
    officeId:['6780d8b2367279399c6b7131'],  // stable fibre 
    categoriesEncluded: [
     {
        _id:'69f4521858f51f4de6fe49c3',  // TEP skilled
        inputIds:[] 
      },
      {
        _id:'69f4521858f51f4de6fe49cc',  // TEP unskilled
        inputIds:[] 
      },
      {
        _id:'69f4521858f51f4de6fe49d5',  // repair mechanic
        inputIds:[]
      },
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      {
        _id:'6683a1a1a191133e73ecd944',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
    ]
  },
   {
    companyId:'68060a289a67bc7cdd97bc36',   //Grasim
    officeId:['68060e179a67bc7cdd97c1c2'],  // stable fibre 
    categoriesEncluded: [
      {
        _id:'69e711e2f6b27f45a2a66f2d',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69e711e2f6b27f45a2a66f33',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69e711e2f6b27f45a2a66f39',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  },
  {
    companyId:'665af5281270d57b1a0f3bfd',   //Elpro school
    officeId:['665af5b51270d57b1a0f405f'],  //  Hinje
    categoriesEncluded: [
      {
        _id:'6a3254bb70687f6a46a84440',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
     
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  },
  {
    companyId:'665af5281270d57b1a0f3bfd',   //Elpro school
    officeId:['66602c155583aa6ff682d641'],  //  chinch
    categoriesEncluded: [
      {
        _id:'6a32554270687f6a46a85585',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
     
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  }
  

  
]
export const customOfficeWisePreInvitePassCategories = [
  
   {
    companyId:'667bd55c8ab2c2761dcf940c',   //Grasim live
    officeId:['6780d8b2367279399c6b7131'],  // stable fibre 
    categoriesEncluded: [
      {
        _id:'69f07d24e0ce4044fdee601d',  // TEP Skilled
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69f07d24e0ce4044fdee6021',  // TEP Unskilled
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69f07d24e0ce4044fdee6025',  // repair mechanic
        inputIds:[] 
      },
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  },
   {
    companyId:'68060a289a67bc7cdd97bc36',   //Grasim test
    officeId:['68060e179a67bc7cdd97c1c2'],  // stable fibre 
    categoriesEncluded: [
      {
        _id:'69e73ae3f6b27f45a2a683f6',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69e73b33f6b27f45a2a684d0',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      {
        _id:'69e73b33f6b27f45a2a684e1',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  },
  {
    companyId:'69bbd7dd843c29882d92d4d1',   //JLL test
    officeId:['69bbd82f843c29882d92d4fa'],  // Broadgate fibre 
    categoriesEncluded: [
      {
        _id:'6a82d4bbd0ed8e70b78d09b3',  // done
        inputIds:[] // 68f123fe4cacad114c7d8283 = return date
      },
      
    ],
    includeDefaultCategories: true,
    categoriesExcluded:[
      
      
    ]
  }
]

export const RestrictPassApprovalForSomeDaysInVisitorApprovalScreen = [
   {
    companyId:'68060a289a67bc7cdd97bc36',         //test grasim  stable fibre
    officeId:'68060e179a67bc7cdd97c1c2',
    L1:6,         // 7 days, including current date
    L2:6,
    L3:6,
    categoryWise: [
      {
        originalCode: 10,
        days:2
      },
       {
        originalCode: 11,
        days:2
      },
      {
        originalCode: 12,
        days:0.1666
      },
    ],
  },
  {
    companyId:'667bd55c8ab2c2761dcf940c',         //grasim stable fiber live  
    officeId:'6780d8b2367279399c6b7131',
    L1:6,
    L2:6,
    L3:6,
    categoryWise: [
      {
        originalCode: 15,
        days:2
      },
       {
        originalCode: 16,
        days:2
      },
      {
        originalCode: 17,
        days:0.1666
      },
    ],

  },
  {
    companyId:'6901dc76d724162e04ee8288',         //grasim stable fiber live  test
    officeId:'6901dcfcd724162e04eeaa93',
    L1:6,
    L2:6,
    L3:6
  },
  {
    companyId:'686e32f1c9b56a5e732cd55b', //pbpay
    officeId:"686e3358c9b56a5e732cedf7",   
    L1:13,
    L2:13,
    L3:13
  },
  {
    companyId:'691da1f40992610e0074613a', //pathway
    officeId:"691da3390992610e007461a2",   
    L1:1,
    L2:1,
    L3:1,
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'691da1f40992610e0074613a', //pathway
    officeId:"691da3390992610e007461df",   
    L1:1,
    L2:1,
    L3:1,
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)

  },
  {
    companyId:'691da1f40992610e0074613a', //pathway
    officeId:"691da3390992610e007461c0",   
    L1:1,
    L2:1,
    L3:1,
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)

  },
  {
    companyId:'6735e77d41a2fc6b29e4b662', //path way
    officeId:"6735e85f41a2fc6b29e4c085",   
    L1:1,
    L2:1,
    L3:1,
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)

  },
   {
    companyId:'6982fb7c1b36ff0b202b41bb', // Live test company
    officeId:"6982fc3b1b36ff0b202b5c82",   
    L1:1,
    L2:1,
    L3:1,
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)

  },
   {
    companyId:'66f502dcf2fd080e5848a046', // Live test company
    officeId:"66f5035bf2fd080e5848a828",   
    L1:0,
    L2:0,
    L3:0,
  },
  {
    companyId:'68e8a1aa3c2482bd6ab1ec60', // test company
    officeId:"68e8a2f93c2482bd6ab1ecd5",   
    L1:0,
    L2:0,
    L3:0,
  },
  {
    companyId:'6960a62a270665056cf6bad9', // test company
    officeId:"6960a6cc270665056cf6dfe5",   
    L1:0,
    L2:0,
    L3:0,
  },
]
export const RestrictDatesForPreInviteCalender = [
   
  {
    companyId:'686e32f1c9b56a5e732cd55b', //pbpay live
    officeId:"686e3358c9b56a5e732cedf7",   
    days:13
  },
  {
    companyId:'693ffa6702718552b0fd5ed6', //test company
    officeId:"693fff5402718552b0fd630d",   
    days:6
  },
  {
    companyId:'691da1f40992610e0074613a', //test company
    officeId:"691da3390992610e007461a2",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'691da1f40992610e0074613a', //test company
    officeId:"691da3390992610e007461a2",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'691da1f40992610e0074613a', //test company
    officeId:"691da3390992610e007461c0",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
   {
    companyId:'691da1f40992610e0074613a', //test company
    officeId:"691da3390992610e007461df",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
   {
    companyId:'6735e77d41a2fc6b29e4b662', //Live  company
    officeId:"6735e85f41a2fc6b29e4c085",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'6982fb7c1b36ff0b202b41bb', // Live test company
    officeId:"6982fc3b1b36ff0b202b5c82",   
    days:1,
    afterDate: new Date(),
    roles:['Tenant Admin']  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'66f502dcf2fd080e5848a046', // Live test company
    officeId:"66f5035bf2fd080e5848a828",   
    days:0,
    afterDate: new Date(),
    excludedVisitCategories:['695cdc3fd5333b4db37add03', '695cdc3fd5333b4db37add07'], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[]  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'68e8a1aa3c2482bd6ab1ec60', // test company
    officeId:"68e8a2f93c2482bd6ab1ecfa",   
    days:0,
    afterDate: new Date(),
    excludedVisitCategories:['695cfb5bd8e25748a6c2f188', '695cfb5bd8e25748a6c2f18c'], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[]  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
  {
    companyId:'68e8a1aa3c2482bd6ab1ec60', // test company
    officeId:"68e8a2f93c2482bd6ab1ecd5",   
    days:0,
    afterDate: new Date(),
    excludedVisitCategories:['695cfb5bd8e25748a6c2f188', '695cfb5bd8e25748a6c2f18c'], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[]  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },
   {
    companyId:'6960a62a270665056cf6bad9', // test company
    officeId:"6960a6cc270665056cf6dfe5",   
     days:0,
    afterDate: new Date(),
    excludedVisitCategories:['695cfb5bd8e25748a6c2f188', '695cfb5bd8e25748a6c2f18c'], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[]  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
  },

   {
    companyId:'68060a289a67bc7cdd97bc36', // test company
    officeId:"68060e179a67bc7cdd97c1c2",   
    //  days:0,
    afterDate: new Date(),
    excludedVisitCategories:[], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[],  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
    categoryWise: [
      {
        originalCode: 13,
        days:2
      },
       {
        originalCode: 14,
        days:2
      },
      {
        originalCode: 15,
        days:0.1666
      },
    ],
  },
  {
    companyId:'667bd55c8ab2c2761dcf940c', // live grasim
    officeId:"6780d8b2367279399c6b7131",   
    //  days:0,
    afterDate: new Date(),
    excludedVisitCategories:[], // if visit category is mentioned, then restriction will not be applied for that category
    roles:[],  // if roles is not mentioned, then restriction will be applied for all (employee, visitor and host)
    categoryWise: [
      {
        originalCode: 12,
        days:2
      },
       {
        originalCode: 13,
        days:2
      },
      {
        originalCode: 14,
        days:0.1666
      },
    ],
  },

  
  
]


export const CompanyIdsToExcludeOfficesFromAdminDashDropdowns = [
  {
    companyId:'6902140b2b9692931bfad32a',   //alten india test,
    excludeOfficeIds:['690216d52b9692931bfad61b','690216d52b9692931bfad66f','690216d62b9692931bfad6a7','690216d62b9692931bfad6c3','690216d72b9692931bfad6fe']
  },
  {
     companyId:'686f940e9504d540aab9be84',   //alten india live
     excludeOfficeIds: ['686f94cc9504d540aab9f39e','68ba87519ff41a52166f5b4f','68ba87519ff41a52166f5b85','68ba87519ff41a52166f5ba7','68c3c74063208b05e34e602f']
  },
  {
     companyId:'69031f495cf9404903e422b2',   //alten india live test acc
     excludeOfficeIds: ['6903226c5cf9404903e4f28a','6903226c5cf9404903e4f300','6903226d5cf9404903e4f34f','6903226d5cf9404903e4f379','6903226e5cf9404903e4f41f']
  }
]

export const CustomWalkinVisitorQrCodeSubLabel = [

  {
    officeIds : ['690216d52b9692931bfad61b','690216d52b9692931bfad66f','690216d62b9692931bfad6a7','690216d62b9692931bfad6c3','690216d72b9692931bfad6fe'], // alten india test
    subLabel:'Scan the QR Code to Late Checkout',
    productName:'Late Checkout'
  },
   {
    officeIds : ['686f94cc9504d540aab9f39e','68ba87519ff41a52166f5b4f','68ba87519ff41a52166f5b85','68ba87519ff41a52166f5ba7','68c3c74063208b05e34e602f'], // alten india live
    subLabel:'Scan the QR Code to Late Checkout',
    productName:'Late Checkout'
  },
  {
    officeIds : ['6903226c5cf9404903e4f28a','6903226c5cf9404903e4f300','6903226d5cf9404903e4f34f','6903226d5cf9404903e4f379','6903226e5cf9404903e4f41f'], // alten india live test acco
    subLabel:'Scan the QR Code to Late Checkout',
    productName:'Late Checkout'
  }

]
export const OfficeIdsToExcludeShowPassExpiredModalInViewPass = ['690216d52b9692931bfad61b','690216d52b9692931bfad66f','690216d62b9692931bfad6a7','690216d62b9692931bfad6c3','690216d72b9692931bfad6fe', '686f94cc9504d540aab9f39e','68ba87519ff41a52166f5b4f','68ba87519ff41a52166f5b85','68ba87519ff41a52166f5ba7','68c3c74063208b05e34e602f','6903226c5cf9404903e4f28a','6903226c5cf9404903e4f300','6903226d5cf9404903e4f34f','6903226d5cf9404903e4f379','6903226e5cf9404903e4f41f']
export const OfficeIdsForAltenIndia = ['690216d52b9692931bfad61b','690216d52b9692931bfad66f','690216d62b9692931bfad6a7','690216d62b9692931bfad6c3','690216d72b9692931bfad6fe', '686f94cc9504d540aab9f39e','68ba87519ff41a52166f5b4f','68ba87519ff41a52166f5b85','68ba87519ff41a52166f5ba7','68c3c74063208b05e34e602f','6903226c5cf9404903e4f28a','6903226c5cf9404903e4f300','6903226d5cf9404903e4f34f','6903226d5cf9404903e4f379','6903226e5cf9404903e4f41f']

export const CompanyIdsForDisplayingVideoInMultipleLanguage = [
  {
    companyId:'6900a62082e344021c49f48e',
    officeId:'6900a6a182e344021c4a0648',
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/img/Qudify/Grasim_Chemical_Visitor_English%20(1).mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/img/Qudify/Grasim_Chemical_visitor_hindi2.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
  {
    companyId:'68060a289a67bc7cdd97bc36',
    officeId:'68060e179a67bc7cdd97c1a4',
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/img/Qudify/Grasim_Chemical_Visitor_English%20(1).mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/img/Qudify/Grasim_Chemical_visitor_hindi2.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
  {
    companyId:'68db83d11dc16123818b8070',  // plasser india
    officeId:'69f08856e0ce4044fdf1fad4',   // karjan 
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/68db83d11dc16123818b8070/Plasser%20India%20-%20Visitor_English_30072020.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/68db83d11dc16123818b8070/Plasser%20India%20-%20Visitor_Hindi_30072020.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
  {
    companyId:'69bbab3d0395ae371ee60b19',  // Dream test
    officeId:'69bbac7d0395ae371ee60b46',   //  silver fall
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/68db83d11dc16123818b8070/Plasser%20India%20-%20Visitor_English_30072020.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/68db83d11dc16123818b8070/Plasser%20India%20-%20Visitor_Hindi_30072020.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
   {
    companyId:'6496d1e0f2a6ff1d527ab5ea',  // SLMG beverages
    officeId:'649abbbd9db6b43eca016ed6',   //  Trishundi
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/6496d1e0f2a6ff1d527ab5ea/video/English.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/6496d1e0f2a6ff1d527ab5ea/video/Hindi.mp4',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
   {
    companyId:'64a26162cfb700061a38fee5',  // Brindavan Bottlers Pvt. Ltd.
    officeId:'64a26263cfb700061a3904c7',   //  Unnav
    languages: [
       {
        name:'English',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/64a26162cfb700061a38fee5/video/Induction_Video_English.mov',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/24f610192af8ec67ef0b330dcc4b7274_RIC1FD8wWc.png'
      },
      {
        name:'Hindi',
        videoUrl:'https://ik.imagekit.io/qdesq/qudify_prod/64a26162cfb700061a38fee5/video/Induction_Video.mov',
        imgUrl:'https://ik.imagekit.io/qdesq/qdesq/c741329e9fd32160bfdcbb0792dbaa08_72i6mZGdV.png'
      }
    ]
  },
  
]


export const companyIdsToHideOfficeNameInPass = ['6927ee1d53bae058cc8089ca', '6745aa404a3b2f424b9b186b','6a168615915a26a35e47eff8','69eb1a1b5c114513adc7f0ec','6a50adf24655f91ab2700444']
export const companyIdsToShowCustomInformationInPass = ['6927ee1d53bae058cc8089ca', '6745aa404a3b2f424b9b186b']

export const companyIdsForAdamasUniversityCustomizations = ['693ffa6702718552b0fd5ed6', '68c10ca3bc34ec4c510ff3a0']
export const officeIdsForAdamasUniversityCustomizations = [
  {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'693fff5502718552b0fd632d',  // Vehicle,
    id:'vehicle_booking'
  },
  {
    companyId:'693ffa6702718552b0fd5ed6',
    officeId:'693fff5502718552b0fd6348',    // Guest House booking
    id:'guest_house'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'68d2652f8a53530eb3a27045',  // Vehicle
     id:'vehicle_booking'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',
    officeId:'69049c3ed9d15d6dfb005ce7',    // Guest House booking
    id:'guest_house'
  },
   {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'697c983546dd529f7dfd79e4',  // Vehicle,
    id:'vehicle_booking'
  },
   {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'697c983546dd529f7dfd7996',  // Vehicle,
    id:'vehicle_booking'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'6979fb2249d47b7a277467f6',  // Vehicle
     id:'vehicle_booking'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'6979fb2249d47b7a27746851',  // Vehicle
     id:'vehicle_booking'
  }
]
export const officeWiseLabelChangesMeetingRoomBooking = [
  {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'693fff5502718552b0fd632d',  // Vehicle,
    id:'vehicle_booking',
    floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
    productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'693ffa6702718552b0fd5ed6',
    officeId:'693fff5502718552b0fd6348',    // Guest House booking
    id:'guest_house',
    floor: 'Guest House',
    meetingRoom:'Room',
    productName:'Guest Houses',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'68d2652f8a53530eb3a27045',  // Vehicle
     id:'vehicle_booking',
     floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
     productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',
    officeId:'69049c3ed9d15d6dfb005ce7',    // Guest House booking
    id:'guest_house',
    floor: 'Guest House',
    meetingRoom:'Room',
    productName:'Guest Houses',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'697c983546dd529f7dfd79e4',  // Vehicle,
    id:'vehicle_booking',
    floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
    productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'693ffa6702718552b0fd5ed6',  // test
    officeId:'697c983546dd529f7dfd7996',  // Vehicle,
    id:'vehicle_booking',
    floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
    productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'6979fb2249d47b7a277467f6',  // Vehicle
     id:'vehicle_booking',
     floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
     productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },

   
  {
    companyId:'68c10ca3bc34ec4c510ff3a0',   // live 
    officeId:'6979fb2249d47b7a27746851',  // Vehicle
     id:'vehicle_booking',
     floor: 'Vehicle Type',
    meetingRoom: 'Vehicle',
     productName:'Vehicles',
     meetingTitleLabel: 'Booking Title'
  },
  {
    companyId:'6a39094955353e6c9aab16d8',   // Test Royale 
    officeId:'6a390b1b55353e6c9aab1709',  // Vehicle
     id:'royal_hos',
     floor: null,
    meetingRoom: null,
     productName:null,
     meetingTitleLabel: 'Patient Name'
  },
   {
    companyId:'6a265f9a62bc8368f344cd29',   // Live Royale 
    officeId:'6a26608562bc8368f3450ba8',  // 
     id:'royal_hos',
     floor: null,
    meetingRoom: null,
     productName:null,
     meetingTitleLabel: 'Patient Name'
  }


]

export const OfficeIdsToHideCompanyNameInputInCoworkingMeetingRoomBookingScreen = ['6a39094955353e6c9aab16d8', '6a265f9a62bc8368f344cd29'];

export const companyIdsToExcludeSpecificPreInviteCategoryCodesForEmployees = [
  {
    companyId:'6819eef21afb4f5b9094f7f0',
    preInviteCategoryCodes:[4]
  }
]

export const companyIdsToHideQrCodeInMeetingRoomBookingDisplayTabletApp = ['69453c42f764b0642402830d', '6982e80856d2870478cbe149','6912d96935084674ca0e45b8']

export const domainsToDisableSignupsInMeetingRoomBooking = [ 'demo11.com', 'sbicard.com','meeting.com']

export const JLL_UK_offices = ["69b91fdb0395ae371ee43beb", "69b91fdb0395ae371ee43c12", "69b91fdb0395ae371ee43c4f", "69b91fdc0395ae371ee43cdb", "69b91fdd0395ae371ee43dd1", "69b91fdd0395ae371ee43eec", "69b91fde0395ae371ee440a6", "69b2776eac2e016e25b8552a", "69b2776eac2e016e25b85579", "69b2776fac2e016e25b855bf", "69b2776fac2e016e25b85626", "69b2776fac2e016e25b856ca", "69b27770ac2e016e25b85784", "69b27770ac2e016e25b858fa",'69bbd82f843c29882d92d4fa'] 

export const companyIdsForMakingVisitorImageMandatoryInVIPPasses = ["66f502dcf2fd080e5848a046",'68e8a1aa3c2482bd6ab1ec60','667bd55c8ab2c2761dcf940c','68060a289a67bc7cdd97bc36'] 

export const CustomTimePeriodForVMSTabletPassGeneration = [
  {
    companyId:'674803377e37d23bc6c1bc27',  
    timer:120,
  },
  {
    companyId:'69b2b228ac2e016e25ccef68',  
    timer:120,
  },
  {
    companyId:'6982fb7c1b36ff0b202b41bb',  // live test company 
    timer:120,
  }
]

// export const AdityaBirlaCustomVisitCategoryIds = ['69e711e2f6b27f45a2a66f2d','69e711e2f6b27f45a2a66f33','69e711e2f6b27f45a2a66f39','69e73ae3f6b27f45a2a683f6','69e73b33f6b27f45a2a684d0','69e73b33f6b27f45a2a684e1',       '69f07d24e0ce4044fdee601d','69f07d24e0ce4044fdee6021','69f07d24e0ce4044fdee6025']

export const AdityaBirlaCustomVisitCategoryCodes = [
  {
    companyId: '667bd55c8ab2c2761dcf940c', // live
    categoryCodes:[15,16,17, 12,13,14]
  },
  {
    companyId: '68060a289a67bc7cdd97bc36',   // test
    categoryCodes:[10,11,12,13,14,15]
  }
]

export const CompanyIdsToDisableBulkUploadPreInvitePasses = [
   {
    companyId: '667bd55c8ab2c2761dcf940c', // live
    officeId: ['6780d8b2367279399c6b7131'],
    categoryCodes: [ 12,13,14]
  },
  {
    companyId: '68060a289a67bc7cdd97bc36', // test
    officeId: ['68060e179a67bc7cdd97c1c2'],
    categoryCodes:[13,14,15]
  },
] 

export const CompanyIdsToAllowMultipleCheckinCheckoutsForWalkinPasses = [
  {
    companyId:'68db83d11dc16123818b8070',   // plasser india live
    officeId:'69f08856e0ce4044fdf1fad4'   // karjan
  },
  {
    companyId:'69bbab3d0395ae371ee60b19',  // test
    officeId:'69bbac7d0395ae371ee60b46'
  }
]

export const CompanyIdsWithHighUsage = [ 
     "6735e77d41a2fc6b29e4b662","641d3dda252fe632b3ccf905",
      "649edcdf1c311b557c3d04e6", "6675494b4445e64197ffe8e6", 
      "6909ac2de9b5fd01cf52b5a7", "667bd8658ab2c2761dcfdb25", 
      "65a12920ab973878a90acc77", "6645db3e33b5d437db135dc8", 
      "667bd55c8ab2c2761dcf940c","661e13378bad7c6bf16ad73c"
  ]
export const CompanyIdsForAdditionalGuestEmailMandatoryInPreInviteFlow = ['64896da604d4d71e373598ec','6549d073d014c117d329166b','69bbd7dd843c29882d92d4d1']

export const SBICardsCustomizationsCompanyId = ['6a3135115ff38e10041c16c0','6912d96935084674ca0e45b8']

export const CompanyIdsToHideBulkUploadInAddEmployees = ['6a3135115ff38e10041c16c0','6912d96935084674ca0e45b8']

export const EquimIntegrationOfficeIds = [ '69b2776eac2e016e25b8552a', '69bbd82f843c29882d92d4fa']

export const JllCompanyIds = ['64896da604d4d71e373598ec', '69bbd7dd843c29882d92d4d1']

export const CompanyIdsToDisplayAdditionalInformationToSecurityTeamScreen = ['6a3e3719dece0919450deb62','69eb1a1b5c114513adc7f0ec','6a50adf24655f91ab2700444']

export const JLLBroadgateEquimIntegratedOfficeIds = ['69bbd82f843c29882d92d4fa','69b2776eac2e016e25b8552a']

export const CategoryWiseCompanyLogo = [
  {
    companyId:'69bbd7dd843c29882d92d4d1',   //JLL test
    officeId:['69bbd82f843c29882d92d4fa'],  // Broadgate fibre 
    categgoryCodes:[14],
    logo: 'https://ik.imagekit.io/qdesq/qudify_prod/64896da604d4d71e373598ec/LaSalleLogo.jpg'
  },
  {
    companyId:'64896da604d4d71e373598ec',   //JLL test
    officeId:['69b2776eac2e016e25b8552a'],  // Broadgate fibre 
    categgoryCodes:[12],
    logo: 'https://ik.imagekit.io/qdesq/qudify_prod/64896da604d4d71e373598ec/LaSalleLogo.jpg'
  }
]

export const companyIdsToHideAdditionalGuestsInPriInvite = ['69427b046141632141a55c13','6a59f9c99571604e90624ce9','6a54a4f3172f785f1800886b']

export const companyIdsToDisableLongtermPreInvitesForEmployees = ['69847af05cc74c43fb344d57','6937b71dba801c2c7d109cde']
export const companyIdsForStateTransformationCustomizations = ['6a168615915a26a35e47eff8','69eb1a1b5c114513adc7f0ec','6a50adf24655f91ab2700444']
